<template>
  <div :class="theme_css">
    <div id="chat_page_main">
      <!-- 上传照片 -->
      <input type="file" id="___file_upload" ref="referenceUpload" accept="image/*" @change="upload"/>

      <!-- 顶部 -->
      <div class="nav-top" :style="{'background': top_bg}">
        <div class="nav-left" @click="back()">
          <img src="../../assets/img/返回箭头.png" class="nav-img" />
          <span class="nav-lable ub ub-ac ub-pc">
            <span class="other-msg" v-if="other_msg > 0">{{ other_msg }}</span>
          </span>
        </div>
        <div class="nav-middle">
          {{ uinfo_to.nick.length > 6 ? uinfo_to.nick.substr(0, 5) + "..." : uinfo_to.nick}}
          <span :class="to_online ? 'online' : 'no-online'">[{{ to_online_tag }}]</span>
        </div>
        <div class="nav-right" @click="onMore()">
          <span class="nav-lable"></span>
          <img src="../../assets/img/更换.png" class="nav-img" />
        </div>
      </div>

      <!-- 添加好友提示 -->
      <div class="fix-applyfriend ub ub-pc" v-if="!is_friend && txts.length > 8 && friend_tip">
        <div @click="apply_friend()">
          对方和你还不是好友，系统已自动开启敏感词汇屏蔽功能，点击<span class="imp">申请好友</span>，即可<span class="imp">解除屏蔽</span>
        </div>
        <div @click="close_friend_tip()" style="margin-left: 0.5em">
          <img src="../../assets/img/移除.png" class="remove" />
        </div>
      </div>

      <!-- 双方信息面板 -->
      <div id="math_block" class="info-block ub ub-ac ub-pc" @click="wnd_click()">
        <div class="info-item ub ub-ver ub-f1" :style="{ 'background-color': bgcolor }">
          <div class="ub">
            <div class="ub ub-ver ub-pc ub-f1">
              <div class="info-img">
                <img :src="uinfo_to.photo" class="info-img" @click="goto_homepage()"/>
              </div>

              <div class="info-sex-age ub ub-pc">
                <img :src=" uinfo_to.sex == '女生' ? require('../../assets/img/女.png') : require('../../assets/img/男.png')" class="info-sex-img"/>
                <span>{{ uinfo_to.age_range }}</span>
              </div>
              <div class="info-value ub ub-pc">
                <span v-if="uinfo_to.sex == '女生'">魅力值:{{ uinfo_to.show_score >0 ? uinfo_to.show_score : uinfo_to.score_total }}</span>
                <span v-if="uinfo_to.sex == '男生'">豪气值:{{uinfo_to.show_coin>0 ? uinfo_to.show_coin : uinfo_to.coin_total }}</span>
              </div>
            </div>

            <img :src="match_pic" class="info-center-img"/>

            <div class="ub ub-ver ub-pc ub-f1">
              <div class="info-img">
                <img :src="uinfo_from.photo" class="info-img"/>
              </div>
              <div class="info-sex-age ub ub-pc">
                <img :src=" uinfo_from.sex == '女生' ? require('../../assets/img/女.png') : require('../../assets/img/男.png')" class="info-sex-img"/>
                <span>{{ uinfo_from.age_range }}</span>
              </div>
              <div class="info-value ub ub-pc">
                <span v-if="uinfo_from.sex == '女生'">魅力值:{{uinfo_from.show_score > 0 ? uinfo_from.show_score : uinfo_from.score_total }}</span>
                <span v-if="uinfo_from.sex == '男生'">豪气值:{{uinfo_from.show_coin > 0 ? uinfo_from.show_coin : uinfo_from.coin_total }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 风险提示 -->
      <div class="risk-blobk ub ub-ac ub-pc" v-if="uinfo_to.risk_tip">
          <div class="risk ub ub-pc ub-ac2">
            <div class="warn ub ub-ac ub-pc">!</div>
            <span>{{ uinfo_to.risk_tip }}</span>
            <div class="close ub ub-ac ub-pc" @click="close_risk()"><img src="../../assets/img/移除.png" alt=""></div>
          </div>
      </div>

      <!-- 聊天 -->
      <div class="msg-block" :style="{ 'margin-bottom': s_margin_bom, 'min-height': s_min_h }" @click="wnd_click()">
        <div class="ub ub-ac">
          <div class="msg-system">请文明聊天，平台坚决打击一切不文明行为!</div>
        </div>
        <!-- 语音测试
        <div>{{msg_voice_pre.tag}}---{{msg_voice_pre.msg.msg_txt.time}}---状态</div>
        <div>{{msg_voice_cur.tag}}---{{msg_voice_cur.msg.msg_txt.time}}---{{voice_play_state}}</div>
        -->
        <div class=" ub ub-ac" v-if="show_chatScore_tips">
            <div class="msg-system" >跟ta聊天，可获得积分收入，回复越及时，收益越高</div>
        </div>

        <!-- 加载历史消息 -->
        <div class="load-history-msg ub ub-ac" v-if="txts.length !== 0" @click="get_history_msg()">
          <img src="../../assets/img/new/历史消息.png" class="history-msg-img" />
          {{ history_tip }}
        </div>
        <div class="no-history-msg" v-if="history_tip == ''"> 没有更多消息了~</div>

        <!-- 历史消息 -->
        <div v-for="(item, index) in history_msg" :key="index + 'his'">
          <!-- 对方历史消息 -->
          <div class="msg-item ub ub-pc us-ae" v-if="item.uid_from == to">
            <img :src="uinfo_to.photo" class="msg-img" />

            <!--文字-->
            <div class="msg-Angle-left" v-if="item.type == 'text'"></div>
            <div class="msg-content msg-left-color" v-if="item.type == 'text'">
              {{ item.txt }} 
            </div>

            <!--表情-->
            <img :src="item.txt" class="msg-emoji" v-if="item.type == 'emoji'" />

            <!--gif-->
            <img :src="item.txt" class="msg-gif" v-if="item.type == 'gif'" />

            <!--pic-->
            <img :src="item.txt" @click="show_full(item.txt)" class="msg-pic" v-if="item.type == 'pic'"/>

            <!--语音-->
            <div class="msg-voice-left ub ub-pe" v-if="item.type == 'voice'">
              <div class="msg-voice msg-leftVoice-color ub ub-pc">
                <img v-if="!themeDark" src="../../assets/img/new2024/audio.png" alt="">
                <img v-if="themeDark" src="../../assets/img/new2024/audio_dark.png" alt="">
                <span class="ss">{{ item.txt.time }}''</span>
              </div>
              <div class="expire">已过期</div>
            </div>

            <!--礼物-->
            <div class="gift-block ub ub-pc" v-if="item.type == 'gift'">
              <div class="gift-txt ub ub-pc ub-ac">
                <img :src="item.txt" class="msg-gift" />
              </div>
              <div class="gift-info ub ub-ver">
                <span class="gift-name">-</span>
                <span class="gift-man">送给&nbsp;{{ uinfo_from.nick }}</span>
                <span class="gift-integral">-</span>
              </div>
            </div>

            <!--系统-拉黑-->
            <div class="msg-sys msg-left-color" v-if="item.type == '拉黑'">
              {{ item.txt }}
            </div>

            <!--系统-加好友-->
            <div class="msg-sys msg-left-color" v-if="item.type == 'sys_friend' && item.txt != '发送申请'">
              {{ item.txt }}
            </div>

            <!--系统-加好友（收到加好友请求）-->
            <div class="friend-block ub ub-pc ub-ac ub-ver" v-if="item.type == 'sys_friend' && item.txt == '发送申请'">
              {{ item.txt }}
            </div>

          </div>

          <!-- 本人历史消息 -->
          <div class="msg-item ub ub-pc ub-ae" v-if="item.uid_from == uid">
            <!--文字-->
            <div class="msg-content msg-right-color" v-if="item.type == 'text'">
              {{ item.txt }}
            </div>
            <div class="msg-Angle-right" v-if="item.type == 'text'"></div>

            <!--表情-->
            <img :src="item.txt" class="msg-emoji" v-if="item.type == 'emoji'" />

            <!--gif-->
            <img :src="item.txt" class="msg-gif" v-if="item.type == 'gif'" />

            <!--pic-->
            <img :src="item.txt" @click="show_full(item.txt)" class="msg-pic" v-if="item.type == 'pic'"/>

            <!--语音-->
            <div class="mag-voice-right  ub ub-pe" v-if="item.type == 'voice'">
              <div class="expire ub ub-ae">已过期</div>
              <div class="msg-voice-history msg-right-color ub ub-ae ub-pc">
                <span class="ss">{{ item.txt.time }}''</span>
                <img v-if="!themeDark" src="../../assets/img/new2024/audio_self.png" alt="">
                <img v-if="themeDark" src="../../assets/img/new2024/audio_self_dark.png" alt="">
              </div>
            </div>

            <!--礼物-->
            <div class="gift-block ub ub-pc" v-if="item.type == 'gift'">
              <div class="gift-txt ub ub-pc ub-ac">
                <img :src="item.txt" class="msg-gift" />
              </div>
              <div class="gift-info ub ub-ver">
                <span class="gift-name">-</span>
                <span class="gift-man">送给&nbsp;{{ uinfo_to.nick }}</span>
                <span class="gift-integral">-</span>
              </div>
            </div>

            <!--系统-拉黑-->
            <div class="msg-sys msg-right-color" v-if="item.type == '拉黑'">
              {{ item.txt }}
            </div>

            <!--系统-加好友-->
            <div class="msg-sys msg-right-color" v-if="item.type == 'sys_friend'">
              {{ item.txt }}
            </div>

            <img :src="uinfo_from.photo" class="msg-img" />

          </div>

          <!-- 系统消息 -->
          <div class="sys-msg ub ub-ac" v-if="item.type == 'sys'">
            <div class="msg-system">{{ item.txt }}</div>
          </div>
        </div>

        <!-- 显示时间：今天 -->
        <div class="sys-msg ub ub-ac" v-if="history_msg.length > 0">
          <div class="msg-system">今天</div>
        </div>

        <!--当前消息-->
        <div v-for="(item, index) in txts" :key="index">
          <!-- 对方消息 -->
          <div class="msg-item ub ub-pc us-ae" v-if="item.tag == 'to'">
            <img :src="uinfo_to.photo" class="msg-img" @click="goto_homepage()"/>

            <!--文字-->
            <div class="msg-Angle-left" v-if="item.msg.msg_type == 'text'"></div>
            <div class="msg-content msg-left-color" v-if="item.msg.msg_type == 'text'">
              {{ is_friend ? item.msg.msg_txt_old : item.msg.msg_txt }}
            </div>

            <!--表情-->
            <img :src="item.msg.msg_txt" class="msg-emoji" v-if="item.msg.msg_type == 'emoji'"/>

            <!--gif-->
            <img :src="item.msg.msg_txt" class="msg-gif" v-if="item.msg.msg_type == 'gif'"/>

            <!--pic-->
            <img :src="item.msg.msg_txt" @click="show_full(item.msg.msg_txt)" class="msg-pic" v-if="item.msg.msg_type == 'pic'"/>

            <!--语音-->
            <div class="msg-voice-left ub ub-pe" v-if="item.msg.msg_type == 'voice'">
              <div class="msg-voice msg-leftVoice-color ub ub-pc" @click="play_voice(item)" >
                <img v-if="!(item.msg.msg_txt.serverId == msg_voice_cur.msg.msg_txt.serverId && voice_play_state == 1) && !themeDark" src="../../assets/img/new2024/audio.png" alt="">
                <img v-if="!(item.msg.msg_txt.serverId == msg_voice_cur.msg.msg_txt.serverId && voice_play_state == 1) && themeDark" src="../../assets/img/new2024/audio_dark.png" alt="">
                <img v-if="(item.msg.msg_txt.serverId == msg_voice_cur.msg.msg_txt.serverId && voice_play_state == 1) && !themeDark" src="../../assets/img/new2024/audioPlay.gif" alt="">
                <img v-if="(item.msg.msg_txt.serverId == msg_voice_cur.msg.msg_txt.serverId && voice_play_state == 1) && themeDark" src="../../assets/img/new2024/audioPlay_dark.gif" alt="">
                <span class="ss">{{ item.msg.msg_txt.time }}''</span>
              </div>
              <div class="loading" v-if="(item.msg.msg_txt.serverId == msg_voice_cur.msg.msg_txt.serverId && voice_play_state == 3)">
                  <img src="../../assets/img/new2024/loading.gif" alt="">
              </div>
              <div class="no-read" v-if="item.msg.msg_txt.localId == '' && voice_play_state !== 3">
                  <div class="red-point"></div>
              </div>
              <div class="expire" v-if="(new Date().getTime() - new Date(item.dtm.replace(/-/g, '/')).getTime()) > 2*24*60*60*1000">已过期</div>
            </div>
            
            

            <!--礼物-->
            <div class="gift-block ub ub-pc" v-if="item.msg.msg_type == 'gift'">
              <div class="gift-txt ub ub-pc ub-ac">
                <img :src="item.msg.msg_txt" class="msg-gift" />
              </div>
              <div class="gift-info ub ub-ver">
                <span class="gift-name">{{ item.msg.msg_attach.name }}(魅力+{{ item.msg.msg_attach.score }})</span>
                <span class="gift-man">送给&nbsp;{{ uinfo_from.nick }}</span>
                <span class="gift-integral" >获得{{ item.msg.msg_attach.score }}积分</span>
              </div>
            </div>

            <!--系统-拉黑-->
            <div class="msg-sys msg-left-color" v-if="item.msg.msg_type == '拉黑'">
              {{ item.msg.msg_txt }}
            </div>

            <!-- 收到拜师申请 -->
            <div class="friend-block ub ub-pc ub-ac ub-ver" v-if="item.msg.msg_type == '拜师'">
              <div class="desc" style="color: #333">对方申请拜你为师</div>
              <div class="state ub">
                <div class="yes"  @click="master_rst('同意')" style="background-color: #d3083a">同意</div>
                <div class="no" @click="master_rst('拒绝')" style="background-color: #009944">拒绝</div>
              </div>
            </div>

            <!--拜师结果-->
            <div class="msg-sys msg-left-color" v-if="item.msg.msg_type == '拜师结果'">
              对方{{ item.msg.msg_txt }}了你的拜师申请
            </div>

            <!--系统-加好友-->
            <div class="msg-sys msg-left-color" v-if=" item.msg.msg_type == 'sys_friend' && item.msg.msg_txt != '发送申请'">
              {{ item.msg.msg_attach }}
            </div>

            <!--系统-加好友（收到加好友请求）-->
            <div class="friend-block ub ub-pc ub-ac ub-ver" v-if=" item.msg.msg_type == 'sys_friend' && item.msg.msg_txt == '发送申请'">
              <div class="desc"> 
                {{ item.msg.msg_attach }}<br />
                <span style="font-size: 0.85em" v-if="friend_apply_rst == 0">选择同意,你将获得300积分</span>
                <span style="font-size: 0.85em" v-if="friend_apply_rst == 1">已同意,你已成功获得300积分</span>
                <span style="font-size: 0.85em" v-if="friend_apply_rst == 2">已拒绝,你错过了300积分</span>
              </div>
              <div class="state ub" v-if="friend_apply_rst == 0">
                <div class="yes" @click="friend_apply(1)">同意</div>
                <div class="no" @click="friend_apply(0)">拒绝</div>
              </div>
            </div>
          </div>

          <!-- 聊天挣积分 -->
          <div class="add-score ub ub-pc" v-if="item.tag == 'to'">
                <div v-if="item.receive_score > 0" class="add ub ub-pc">
                    +{{item.receive_score}}积分
                </div>
           </div>

          <!-- 违规消息 -->
          <div class="msg-violate-regulations" v-if="item.msg.msg_type == 'text' && item.tag == 'to' && item.msg.msg_txt_old !== item.msg.msg_txt">
            <span> 若对方发送的消息让你感到不适，请 <label @click="report_click()">点击举报</label> ；点击了解<label @click="goto_chat_specification()">社区自治</label> ，共建共治社区氛围。</span>
          </div>

          <!-- 本人消息 -->
          <div class="msg-item ub ub-pc ub-ae" v-if="item.tag == 'self'">
            <!--文字-->
            <span class="msg-tip">●</span>
            <div class="msg-content msg-right-color" v-if="item.msg.msg_type == 'text'">
              {{ item.msg.msg_txt }}
            </div>
            <div class="msg-Angle-right" v-if="item.msg.msg_type == 'text'"></div>

            <!--表情-->
            <img :src="item.msg.msg_txt" class="msg-emoji" v-if="item.msg.msg_type == 'emoji'"/>

            <!--gif-->
            <img :src="item.msg.msg_txt" class="msg-gif" v-if="item.msg.msg_type == 'gif'"/>

            <!--pic-->
            <img :src="item.msg.msg_txt" @click="show_full(item.msg.msg_txt)" class="msg-pic" v-if="item.msg.msg_type == 'pic'"/>

            <!--语音-->
            <div class="mag-voice-right ub ub-pe" v-if="item.msg.msg_type == 'voice'">
              <div class="expire ub ub-ae" v-if="(new Date().getTime() - new Date(item.dtm.replace(/-/g, '/')).getTime()) > 2*24*60*60*1000">已过期</div>
              <div class="msg-voice msg-right-color ub ub-ae ub-pc" @click="play_voice(item)">
                <span class="ss">{{ item.msg.msg_txt.time }}''</span>
                <img v-if="!(item.msg.msg_txt.serverId == msg_voice_cur.msg.msg_txt.serverId && voice_play_state == 1) && !themeDark" src="../../assets/img/new2024/audio_self.png" alt="">
                <img v-if="!(item.msg.msg_txt.serverId == msg_voice_cur.msg.msg_txt.serverId && voice_play_state == 1) && themeDark" src="../../assets/img/new2024/audio_self_dark.png" alt="">
                <img v-if="(item.msg.msg_txt.serverId == msg_voice_cur.msg.msg_txt.serverId && voice_play_state == 1) && !themeDark" src="../../assets/img/new2024/audioPlay_self.gif" alt="">
                <img v-if="(item.msg.msg_txt.serverId == msg_voice_cur.msg.msg_txt.serverId && voice_play_state == 1) && themeDark" src="../../assets/img/new2024/audioPlay_self_dark.gif" alt="">
              </div>
            </div>

            <!--礼物-->
            <div class="gift-block ub ub-pc" v-if="item.msg.msg_type == 'gift'">
              <div class="gift-txt ub ub-pc ub-ac">
                <img :src="item.msg.msg_txt" class="msg-gift" />
              </div>
              <div class="gift-info ub ub-ver">
                <span class="gift-name">{{ item.msg.msg_attach.name }}(魅力+{{ item.msg.msg_attach.score }})</span>
                <span class="gift-man">送给&nbsp;{{ uinfo_to.nick }}</span>
                <span class="gift-integral" >对方获得{{ item.msg.msg_attach.score }}积分</span>
              </div>
            </div>

            <!--系统-拉黑-->
            <div class="msg-sys msg-right-color" v-if="item.msg.msg_type == '拉黑'">
              {{ item.msg.msg_txt }}
            </div>

            <!--系统-加好友-->
            <div class="msg-sys msg-right-color" v-if="item.msg.msg_type == 'sys_friend'">
              {{ item.msg.msg_attach }}
            </div>

            <!-- 拜师申请 -->
            <div class="msg-sys msg-right-color" v-if="item.msg.msg_type == '拜师'">
              {{ item.msg.msg_txt }}
            </div>

            <!-- 拜师结果 -->
            <div  class="msg-sys msg-right-color" v-if="item.msg.msg_type == '拜师结果'">
              我{{ item.msg.msg_txt }}了你的拜师申请
            </div>

            <img :src="uinfo_from.photo" class="msg-img" v-if="item.msg.msg_type !== 'sys_payCoin' && item.msg.msg_type !== 'sys_changeCoin'"/>

          </div>

          <!-- 语音收入 -->
          <div class="add-score add-score-right ub ub-ae" v-if="item.tag == 'self'">
                <div v-if="item.to_res_tag && item.msg.msg_txt.coin" class="add ub ub-pc">
                    +{{ item.msg.msg_txt.coin }}积分
                </div>
           </div>

          <div class="ub ub-ac" v-if="item.tag == 'sys'">
            <div class="msg-system">{{ item.msg.msg_txt }}</div>
          </div>

          <div class=" ub ub-ac" v-if="item.msg.msg_type == 'sys_payCoin'">
            <div class="msg-system system-paycoin">{{ item.msg.msg_txt }}</div>
          </div>

          <div class="ub ub-ac" v-if="item.msg.msg_type == 'sys_changeCoin'">
            <div class="msg-system system-paycoin">{{ item.msg.msg_txt }}</div>
          </div>

        </div>
        
        <!-- 赠送礼物对方离线提示 -->
        <div v-if="offline_state" >
            <div v-if="msg_pre.type != 'gift'" class="msg-system"><a @click="wxsend_tip()">ta不在线哦，未能及时看到此消息，可使用<span class="summon-online">召唤上线功能</span>，快速通知ta上线~</a></div>
            <div v-if="msg_pre.type == 'gift'" class="msg-system summon-success">小火柴已为你召唤成功</div>
        </div>

      </div>

      <!--系统-打招呼-->
      <transition name="fade">
        <div v-show="show_hello" class="hello-block">
          <div class="hello-block-title">跟Ta打个招呼吧~</div>
          <div class="hello-block-pic ub ub-ac3">
            <div class="ub-ac ub-pc" v-for="(item, index) in hello_gif" :key="index" @click="hello_click(item)">
              <img :src="item" class="hello-gif" />
            </div>
          </div>
        </div>
      </transition>

      <!-- 发送信息 -->
      <div id="send_block" class="send-block ub ub-ver">
        <div class="ub ub-pc send-txt-con" v-if="!hide_msg_input()">
          <input class="send-txt ub-f1" type="text" placeholder="请输入新消息" v-model="txt" @blur="iosBlur()" @focus="txtFocus()"/>
          <div class="btn-send" v-if="show_send_btn" @click="send_txt()">
            <span>发 送</span>
          </div>
        </div>

        <chat_voice @send_voice="send_voice" :center="arry_menu['menu_1']" :toUid="to" @close_voice="close_voice" @reset_chat_wx="reset_wx"></chat_voice>
        <chart_gift v-if="arry_menu['menu_3']" @send_gift="send_gift" :toUid="to" ></chart_gift>
        <chart_gif v-if="arry_menu['menu_4']" @send_gif="send_gif"></chart_gif>
        <chart_em v-if="arry_menu['menu_5']" @send_emoji="send_emoji"></chart_em>
        <chart_topic v-if="arry_menu['menu_6']" @send_topic="send_topic" @close_topic="close_topic"></chart_topic>

        <!-- 底部功能-----start -->
        <div class="send-img ub ub-pc">
          <div class="ub ub-ac up-pc ub-f1">
            <img v-if="arry_menu['menu_1']" src="../../assets/img/new/语音-1.png" class="send-img-item" @click="ctrl_menu(1)"/>
            <img v-if="!arry_menu['menu_1']" src="../../assets/img/new/语音.png" class="send-img-item" @click="ctrl_menu(1)"/>
          </div>
          <div class="ub ub-ac up-pc ub-f1">
            <img v-if="arry_menu['menu_2']" src="../../assets/img/new/图片-1.png" class="send-img-item" @click="ctrl_menu(2)"/>
            <img v-if="!arry_menu['menu_2']" src="../../assets/img/new/图片.png" class="send-img-item" @click="ctrl_menu(2)"/>
          </div>
          <div class="ub ub-ac up-pc ub-f1">
            <img v-if="arry_menu['menu_3']" src="../../assets/img/new/礼物-1.png" class="send-img-item" @click="ctrl_menu(3)"/>
            <img v-if="!arry_menu['menu_3'] && is_festival == 0" src="../../assets/img/new/礼物-2.png" class="send-img-item" @click="ctrl_menu(3)"/>
            <img v-if="!arry_menu['menu_3'] && is_festival == 1" src="../../assets/img/new/礼物-3.png" class="send-img-item" @click="ctrl_menu(3)"/>
          </div>
          <div class="ub ub-ac up-pc ub-f1">
            <img v-if="arry_menu['menu_6']" src="../../assets/img/new/话题-1.png" class="send-img-item" @click="ctrl_menu(6)"/>
            <img v-if="!arry_menu['menu_6']" src="../../assets/img/new/话题.png" class="send-img-item" @click="ctrl_menu(6)"/>
          </div>
          <div class="ub ub-ac up-pc ub-f1">
            <img v-if="arry_menu['menu_4']" src="../../assets/img/new/gif-1.png" class="send-img-item" @click="ctrl_menu(4)"/>
            <img v-if="!arry_menu['menu_4']" src="../../assets/img/new/gif.png" class="send-img-item" @click="ctrl_menu(4)"/>
          </div>
          <div class="ub ub-ac up-pc ub-f1">
            <img v-if="arry_menu['menu_5']" src="../../assets/img/new/表情-1.png" class="send-img-item" @click="ctrl_menu(5)"/>
            <img v-if="!arry_menu['menu_5']" src="../../assets/img/new/表情.png" class="send-img-item" @click="ctrl_menu(5)"/>
          </div>
        </div>
        <!-- 底部功能-----end -->
      </div>

      <warn ref="formshow_warn"></warn>
      <alert ref="myConfirm"></alert>
      <alert ref="myConfirm_buyCoin" @userBehavior="formact_buycoin"></alert>
      <alert ref="myConfirm_buyCoinOrchatcoin" @userBehavior="formact_buycoinOrchatcoin"></alert>
      <alert ref="myConfirm_buyVip" @userBehavior="formact_buyVip"></alert>

      <dlg ref="myForm"></dlg>
      <dlg ref="myForm_sendPic" @formBehavior="formact_sendPic"></dlg>
      <dlg ref="myForm_lahei" @formBehavior="formact_lahei"></dlg>
      <dlg ref="myForm_applyFriend" @formBehavior="formact_applyFriend"></dlg>
      <dlg ref="myForm_wxsend" @formBehavior="formact_wxsend"></dlg>
      <dlg ref="myForm_voiceCoin" @formBehavior="formact_voiceCoin"></dlg>

      <kill_alert ref="show_kill"></kill_alert>
      <full_pic ref="myFullPic"></full_pic>
      <first_charge ref="first_charge"></first_charge>

      <ryt-dropdown v-model="rytDropdown_1" :actions="actions_1" :center="rytDropdown_1" @clickOption="chooseOption_1" 
        title="更多" 
        cancelText="关闭/取消"
        cancenTextColor="#fff">
      </ryt-dropdown>

      <ryt-dropdown v-model="rytDropdown_2" :actions="actions_2" :center="rytDropdown_2" @clickOption="chooseOption_2"
        title="举报完全匿名,请放心举报"
        cancelText="关闭/取消"
        cancenTextColor="#fff">
      </ryt-dropdown>

    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";
import Exif from "exif-js";
import * as tool from "../../api/common";
import Chart_Em from "./Chart_Emoji.vue";
import Chart_Gif from "./Chart_Gif.vue";
import Chart_Gift from "./Chart_Gift.vue";
import Chart_Topic from "./Chart_Topic.vue";
import Alert from "../../components/Alert.vue";
import full_pic from "../../components/Full_Pic.vue";
import Form from "../../components/Form.vue";
import rytDropdown from "../../components/Dropdown.vue"; //下拉框带popup蒙层
import Warn from "../../components/Warning.vue";
import Kill_Alert from "../../components/Kill_Alert.vue";
import First_Charge from "../../components/First_Charge.vue";
import Chat_Voice from "./Chat_Voice.vue";
export default {
  components: {
    chart_em: Chart_Em,
    chart_gif: Chart_Gif,
    chart_gift: Chart_Gift,
    chart_topic: Chart_Topic,
    alert: Alert,
    full_pic: full_pic,
    dlg: Form,
    warn: Warn,
    "ryt-dropdown": rytDropdown,
    "kill_alert": Kill_Alert,
    first_charge: First_Charge,
    chat_voice: Chat_Voice
  },
  data() {
    return {
      uid: "",
      to: "",
      txt: "",

      uinfo_from: {
        photo: "",
        nick: "",
        sex: "",
        age_range: "",
        score_total: 0,
        coin_total: 0,
      },
      uinfo_to: {
        photo: "",
        nick: "",
        sex: "",
        age_range: "",
        score_total: 0,
        coin_total: 0,
      },

      match_pic: "",
      bgcolor: "#dcdcdc",
      to_online: true,
      to_online_tag: "在线",
      pre_send_time: new Date(),

      //发送图片
      headerImage: "",
      picValue: "",

      s_margin_bom: "5em",
      s_min_h: "10em",

      arry_menu: {
        menu_1: false,
        menu_2: false,
        menu_3: false,
        menu_4: false,
        menu_5: false,
        menu_6: false,
      },

      actions_1: {
        // 1: "查看主页",
        2: "修改备注",
        3: "添加好友",
        4: "拜师",
        5: "聊天举报",
        6: "拉黑",
        7: "礼物投诉"
      },
      rytDropdown_1: false,

      actions_2: {
        1: "色情低俗",
        2: "政治敏感",
        3: "辱骂他人",
        4: "垃圾广告",
        5: "冒充官方",
        6: "非法行为",
        7: "涉嫌欺诈",
        8: "其他",
      },
      rytDropdown_2: false,

      friend_apply_rst: 0,
      is_friend: false,

      is_festival: 0,

      show_hello: false,
      hello_gif: [],
      friend_tip: true,

      msg_count: 0,

      history_msg: [],
      history_tip: "历史消息",
      history_time: "",

      wnd_hight: 0,
      msg_pre:'',

      offline_state:0,
      top_bg: "",
      lastComplainTimes: {},
      show_chatScore_tips: false,
      voice_play_state:0, //0==未开始； 1==播放； 2==暂定； 3==下载；
      msg_voice_pre: {
        "dtm": "",
        "dtm_sp": "",
        "msg": {
            "msg_type": "voice",
            "msg_txt": {
                "localId": "",
                "serverId": "",
                "time": 0
            }
        },
        "tag": "",
        "read_tag": false
    },
      msg_voice_cur: {
        "dtm": "",
        "dtm_sp": "",
        "msg": {
            "msg_type": "voice",
            "msg_txt": {
                "localId": "",
                "serverId": "",
                "time": 0
            }
        },
        "tag": "",
        "read_tag": false
    },
      themeDark: false,
      arr_preLength: 0,
      voice_click_dtm: ""
    };
  },
  sockets: {
    //消息发送完成后的回执（服务器返回的发送状态）
   send_one_rst(data) {
      var self = this;
      if (data == "fail") {
        //发送离线礼物通知（微信通知）
        if(this.msg_pre.type == "gift"){
          this.wxSendMsg(this.msg_pre);
        }
        var message = this.$store.state.message;
        var to = this.to;
        var sum = tool.sum_chart(message, to);
        var count_total = sum.count_total;
        var count_self = sum.count_self;
        if (count_self > 1) {
          this.to_online = false;
          this.to_online_tag = "离线";
          //弹出提示
          //this.$toast.bottom("对方暂时离线,此条消息已成功发送~");
          if (this.msg_pre.type != "check_complain") {
            this.offline_state += 1;
            setTimeout(() => {
              self.offline_state--;
            }, 5000);
          }
        }
      } else {
        this.to_online = true;
        this.to_online_tag = "在线";
        setTimeout(() => {
           if(self.$store.state.objVal.setting.msg_vol_2){
            if (self.$store.state.objVal.voice_state == 0) {
              tool.playSound_send();
            }
           }

        }, 100);
      }
      //每次发送消息，做封号检查
      this.check_kill();
      //每发送10次消息，做警告检查
      var msg_count = this.$store.state.msg_count;
      //console.log(msg_count);
      if(msg_count % 10 == 0){
        this.check_warn();
      }

    },
  },
  mounted() {
    const that = this;
    window.onresize = function temp() {
      //安卓手机键盘弹出关闭都执行次动作，苹果手机不执行
      that.set_MsgBlock_MinH();
    };

    document.onkeydown = function (e) {
      var key = window.event.keyCode;
      if (key == 13) {
        that.send_txt();
      }
    };

    this.init_page();


    /******************************************************** */
    //兼容性处理（兼容苹果手机）----start -------------------------
    var h1 = window.innerHeight;
    this.wnd_hight = h1;
    var client = this.$store.state.client;

    if (client.is_ios) {
      // 获取触摸坐标
      let _this = this;
      document.body.addEventListener("touchstart", _this.touchstartFunction, {
        passive: false,
      });

      let el = document.querySelector("#chat_page_main"); // 需要滑动的dom元素
      iosTrouchFn(el);

      function iosTrouchFn(el) {
        // el需要滑动的元素
        el.addEventListener("touchmove", function (e) {
          e.isSCROLL = true;
        });
        document.body.addEventListener("touchmove", _this.touchmoveFunction, {
          passive: false,
        }); // passive防止阻止默认事件不生效
      }
    }
    //兼容性处理（兼容苹果手机）----end -------------------------
    /******************************************************** */
  },

  /******************************************************** */
  //兼容性处理（兼容苹果手机）----start -------------------------
  beforeDestroy() {
    var client = this.$store.state.client;
    if (client.is_ios) {
      let _this = this;
      document.body.removeEventListener(
        "touchstart",
        _this.touchstartFunction,
        { passive: false }
      );
      document.body.removeEventListener("touchmove", _this.touchmoveFunction, {
        passive: false,
      });
    }
    
  },
  /******************************************************** */
  //兼容性处理（兼容苹果手机）----end -------------------------

  computed: {
    show_send_btn: function () {
      return this.txt == "" ? false : true;
    },
    txts: function () {
      var arr = [];
      var to_uid = this.to;
      var message = this.$store.state.message;
      var arr_preLength = this.arr_preLength;

      if (to_uid == "") {
        return arr;
      }

      // console.log(new Date());
      var idx = tool.hasKey(message, to_uid, "to");
      if (idx >= 0) {
        arr = arr.concat(message[idx]["txts"]);
      }

      //设置该消息已读
      this.$store.commit("set_message_item_redtag", to_uid);

      //提示信息
      this.show_ads();

      //好友申请结果处理
      this.set_friend_apply_rst(arr);

      if (arr.length > arr_preLength) {
        this.set_scroll_msg();
      }
      // console.log(JSON.stringify(arr));
      this.set_arr_length(arr.length);
      
      return arr;
    },
    other_msg: function () {
      var no_read = 0;
      var message = this.$store.state.message;
      no_read = tool.calculate_noreadAll_count(message);
      return no_read;
    },
    theme_css() {
        var rtn_css = "";
        var client = this.$store.state.client;
        var themeDark = tool.is_theme_dark(this);
        if (client.is_ios) {
            rtn_css = themeDark == true ? "ios_dark" : "ios_light";
        } 
        if (client.is_andriod) {
            rtn_css = themeDark == true ? "andriod_dark" : "andriod_light";
        }
        return rtn_css;
    }
  },

  /**/
  updated: function () {
    this.$nextTick(function () {
      //安卓手机键盘弹出关闭都执行次动作，苹果手机不执行; 输入框内文本内容改变则两个端都执行

      //设置主体div高度
      var h1 = window.innerHeight;
      document.getElementById("chat_page_main").style.height = h1 + "px";

      //苹果手机专门处理
      var client = this.$store.state.client;
      if (client.is_ios) {
        document.getElementById("chat_page_main").style.height =
          this.wnd_hight + "px";
      }

      var h2 = document.getElementById("send_block").clientHeight;
      this.s_margin_bom = h2 + "px";

      //this.set_scroll();
    });
  },

  methods: {
    ...mapMutations(["get", "post", "post2", "wxPlayVoice", "wxStopVoice", "WxConfig", "wxDownloadVoice", "wxStartRecord", "wxStopRecord", "wxUploadVoice", "wxTranslateVoice", "wxOnVoicePlayEnd", "wxPauseVoice"]), //引入方法
    ...mapActions([
      "act_get_userinfo",
      "act_reload_userinfo",
      "act_sub_coin",
      "act_push_mycomplain",
      "act_push_complainmy",
      "act_get_killinfo",
    ]), //引入方法

    /******************************************************** */
    //兼容性处理（兼容苹果手机）----start -------------------------

    iosBlur() {
      let ua = window.navigator.userAgent;
      if (!!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
        //ios系统
        let currentPosition, timer;
        let speed = 1;
        timer = setInterval(function () {
          currentPosition =
            document.documentElement.scrollTop || document.body.scrollTop;
          currentPosition -= speed;
          window.scrollTo(0, currentPosition); //页面向上滚动
          currentPosition += speed;
          window.scrollTo(0, currentPosition); //页面向下滚动
          clearInterval(timer);
          //alert("失去焦点")
          //console.log("失去焦点")
        }, 100);
      }
    },

    // 滑动开始获取初始位置坐标
    touchstartFunction(e) {
      this.startY = e.touches[0].pageY;
    },

    // 监听手指滑动事件
    touchmoveFunction(e) {
      let el = document.querySelector("#chat_page_main"); // 需要滑动的dom元素这个为包裹滑动元素的父元素
      if (!e.isSCROLL) {
        e.preventDefault(); // 阻止默认事件(上下滑动)
        //console.log(‘阻止了’);
      } else {
        // 需要滑动的区域
        let moveY = e.touches[0].pageY;
        let top = el.scrollTop;
        let ch = el.clientHeight; // 对象最顶端和窗口最顶端之间的距离
        let scrollH = el.scrollHeight; // 含滚动内容的元素大小
        if (
          (top === 0 && moveY > this.startY) ||
          (top + ch === scrollH && moveY < this.startY)
        ) {
          e.preventDefault();
          //console.log(‘阻止了’);
        } else {
          //console.log(‘开启了’);
        }
      }
    },

    /******************************************************** */
    //兼容性处理（兼容苹果手机）----end -------------------------

    back() {
      this.$router.go(-1); //返回上一层
    },

    set_MsgBlock_MinH() {
      var h1 = window.innerHeight;
      var h2 = document.getElementById("send_block").clientHeight;
      var h3 = document.getElementById("math_block").clientHeight;
      this.s_min_h = h1 - h2 - h3 - 80 + "px";
    },

    set_scroll() {
      var div = document.getElementById("chat_page_main");
      div.scrollTop = div.scrollHeight;
    },

    set_scroll200() {
      var self = this;
      setTimeout(() => {
        self.set_scroll();
      }, 350);
    },

    set_scroll_msg() {
      var self = this;
      setTimeout(() => {
        self.set_scroll();
        //计算当前消息量
        var message = self.$store.state.message;
        var idx = tool.hasKey(message, self.to, "to");
        if (idx >= 0) {
          self.msg_count = message[idx]["txts"].length;
        }
      }, 100);
    },

    txtFocus() {
      this.set_scroll200();
    },

    hello_click(gif_url) {
      this.show_hello = false;
      //发送gif
      var msg = { msg_type: "gif", msg_txt: gif_url };
      this.send(msg);
    },

    init_page() {
      //初始化基本信息
      this.init_page_baseinfo();

      //好友检测
      this.init_page_checkFriend();

      //检测拉黑情况
      this.check_complain_lahei();

      //加载打招呼信息
      this.init_page_helloInfo();

      //初始化微信配置
      this.init_wx();

      //获取本地消息，不是历史消息
      var msg = sessionStorage.getItem(this.to);
      if (msg) {
        this.history_msg = JSON.parse(msg);
      }

      //获取备注
      this.get_user_note();

      //是否显示回复得积分提示
      this.get_show_chatScore_tips();

      var themeDark = tool.is_theme_dark(this);
      this.themeDark = themeDark;
    },

    init_page_baseinfo() {
      this.uid = this.$store.state.uid;
      var to_uid = "";
      if (this.$route.params.uid) {
        to_uid = this.$route.params.uid;
        this.$store.commit("set_to_uid", to_uid);
      } else {
        to_uid = this.$store.state.to_uid;
      }
      this.to = to_uid;

      if(this.to==this.uid){
        this.back();
      }


      var self = this;
      self.act_get_userinfo({
        uid: self.uid,
        success: function (u) {
          self.uinfo_from = u;
          self.getMatchPic();
        },
      });

      //加载对方信息,根据情况判断是否重新加载信息（增加时间戳方式）
      var userinfo = this.$store.state.userinfo;
      var u_to = "";
      var time_pre = "";
      var dtm_sp_count = -1;
      var idx = tool.hasKey(userinfo, this.to, "uid");
      if (idx >= 0) {
        u_to = userinfo[idx];
        time_pre = u_to.time;
        dtm_sp_count = tool.dateDiff2(new Date(time_pre), new Date());
      }

      if (dtm_sp_count > 30 * 60 || dtm_sp_count == -1) {
        self.act_reload_userinfo({
          uid: self.to,
          success: function (u) {
            self.uinfo_to = u;
            
            self.getMatchPic();
          },
        });
      } else {
        self.uinfo_to = u_to;
        
        self.getMatchPic();
        // console.log(JSON.stringify(self.uinfo_to));
        if(self.uinfo_to.is_kill>0){
          self.$router.push({ name: "banned", params: { nike: self.uinfo_to.nick } });
        }
      }

      //加载dic信息
      var sysdic = this.$store.state.sysdic;
      if (sysdic) {
        this.is_festival = sysdic.is_festival;
      }
    },

    init_page_checkFriend() {
      var my_friend = this.$store.state.my_friend;
      var is_friend = tool.check_friend(my_friend, this.to);
      this.is_friend = is_friend;

      var message = this.$store.state.message;
      var to = this.to;
      var sum = tool.sum_chart(message, to);
      var count_self = sum.count_self;

      if (!is_friend && count_self <= 1) {
        this.$toast.top("你们还不是好友,已自动开启敏感词屏蔽");
      }
    },

    init_page_helloInfo() {
      //检查是否有聊天量
      var message = this.$store.state.message;
      var to = this.to;
      var sum = tool.sum_chart(message, to);
      var count_self = sum.count_self;
      if (count_self > 0) {
        return false;
      }

     //加载打招呼信息
      var const_data = this.$store.state.const_data;
      var hello_gif;
      if(this.uinfo_from.sex == "女生") {
          hello_gif = const_data.hello_girl;
      }
      else {
          hello_gif = const_data.hello_boy;
      }
      if((!hello_gif) || (hello_gif.length <1)) {
        var hello_gif = const_data.hello_gif;
      }

      var len = hello_gif.length;
      var ary_temp = [];
      for (var i = 0; i < len; i++) {
        var rnd = tool.randomNum(1, len - 1);
        if (ary_temp.indexOf(hello_gif[rnd]) == -1) {
          ary_temp.push(hello_gif[rnd]);
        }
        if (ary_temp.length == 3) {
          break;
        }
      }
      if (ary_temp.length == 3) {
        this.hello_gif = ary_temp;
        //延迟显示
        var self = this;
        setTimeout(function () {
          if (self.history_msg.length == 0) {
            self.show_hello = true;
          }
        }, 800);
      }
    },

    init_wx() {
      this.WxConfig({url:window.location.href});
      this.reset_wx();
    },
    reset_wx(){
                this.voice_play_state = 0;
                //停止播放
                if(this.msg_voice_pre.msg.msg_txt.localId){
                    //this.wxStopVoice(this.msg_voice_pre.msg.msg_txt.localId);
                    this.do_stop_voice(this.msg_voice_pre);
                }
                if(this.msg_voice_cur.msg.msg_txt.localId){
                    //this.wxStopVoice(this.msg_voice_cur.msg.msg_txt.localId);
                    this.do_stop_voice(this.msg_voice_cur);
                }
                //停止录音
                var data = {
                    suc: function(res) {}
                };
                this.wxStopRecord(data);
    },

    ctrl_menu(idx) {

      //发图片
      if (idx == 2) {
        this.onSendPic();
      }

      for (var i = 1; i <= 6; i++) {
        if (i != idx) {
          this.arry_menu["menu_" + i] = false;
        }
      }

      if (this.arry_menu["menu_" + idx]) {
        this.arry_menu["menu_" + idx] = false;
      } else {
        this.arry_menu["menu_" + idx] = true;
        this.set_scroll200();
      }
    },

    wnd_click: function () {
      for (var i = 1; i <= 6; i++) {
        this.arry_menu["menu_" + i] = false;
      }
      this.rytDropdown_1 = false;
      this.rytDropdown_2 = false;
    },

    hide_msg_input: function () {
      var brtn = false;
      for (var i = 1; i <= 5; i++) {
        if (this.arry_menu["menu_" + i]) {
          brtn = true;
          return brtn;
        }
      }
      return brtn;
    },

    close_topic() {
      this.arry_menu["menu_6"] = false;
    },

    close_voice() {
      this.wnd_click();
    },

    close_risk() {
      this.uinfo_to.risk_tip = "";
    },

    getMatchPic() {
      var pic_name = "男女.png";
      this.bgcolor = "#FF69B4";
      //设置顶部背景色
      //this.top_bg = "linear-gradient(86deg, rgba(235, 47, 172, 0.9), rgba(198, 93, 219, 0.9))";
      if (this.uinfo_from.sex == "男生" && this.uinfo_to.sex == "男生") {
        pic_name = "男男.png";
        this.bgcolor = "#dcdcdc";
        //this.top_bg = "#b8b6b6";
      }
      if (this.uinfo_from.sex == "女生" && this.uinfo_to.sex == "女生") {
        pic_name = "女女.png";
        this.bgcolor = "#888";
        //this.top_bg = "linear-gradient(86deg,  rgba(114, 76, 121, 0.9), rgba(240, 154, 211, 0.9))";
      }
      this.match_pic = require("../../assets/img/" + pic_name);
    },

    apply_friend() {
      this.formshow_applyFriend();
    },

    /* 发送图片 start */
    onSendPic() {
      var self = this;
      setTimeout(function () {
        self.arry_menu.menu_2 = false;
      }, 1000);

      //聊天前5句话不允许发照片
      var message = this.$store.state.message;
      var to = this.to;
      var sum = tool.sum_chart(message, to);
      var count_self = sum.count_self;
      if (count_self < 3) {
        this.$toast.center("聊热乎了再发照片嘛~");
        return false;
      }

      //绑定手机号码可直接发送照片，不收金币
      if (self.uinfo_from.tel) {
        this.upload_img();
      } else {
        if (!self.$cookies.isKey("cookie_sendpic_coin")) {
          //发送图片收50金币
          var h =
            "为了防止用户受到骚扰，发送照片需要50金币,点击确定即可发送照片同时扣除50金币，本提示每天只进行一次，后续发送照片将默认扣除50金币。前往【我的】->【认证中心】->【手机号码认证】完成手机号码认证，可免费发送照片。";
          self.$refs.myForm_sendPic.show(h, {
            type: "confirm",
            confirmText: "确定",
            titleText: "温馨提示",
            data: "",
          });
          self.$cookies.set("cookie_sendpic_coin", 1, 24 * 60 * 60);
        } else {
          //金币检查
          if (!this.check_coin(50)) {
            return false;
          }
          this.upload_img();
        }
      }
    },

    upload_img() {
      //触发input的change事件
      var ie =
        navigator.appName == "Microsoft Internet Explorer" ? true : false;
      if (ie) {
        document.getElementById("___file_upload").click();
      } else {
        var a = document.createEvent("MouseEvents"); //FF的处理
        a.initEvent("click", true, true);
        document.getElementById("___file_upload").dispatchEvent(a);
      }
    },

    upload(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.picValue = files[0];

      var arrExt = [".png", ".jpg", ".jpeg", ".gif", ".bmp"];
      var file_name = this.picValue.name;
      var fileExt = file_name.substr(file_name.lastIndexOf(".")).toLowerCase();

      if (arrExt.indexOf(fileExt) <= -1) {
        //上传文件格式不正确
        this.$toast.center("不支持您所选的图片格式~");
        return false;
      }

      //toast 启动动画
      this.$loading("发送中...");
      var self = this;
      setTimeout(()=>{
        self.$loading.close();
      },5000)

      this.imgPreview(this.picValue);
    },

    postImg() {
      var self = this;
      //这里写接口
      var base64 = this.headerImage;
      let param = new FormData(); // 创建form对象
      param.append("imgFile", base64); //对应后台接收图片名

      //判断base64 是否成功, 长度>10
      if (base64.length < 10) {
        //消掉动画
        self.$loading.close();
        self.$toast.center("图片处理失败,请重新选择");
        return false;
      }

      this.post2({
        url: "/Common/UpLoadImage_Base64",
        data: param,
        success: function (serve_data) {
          //消掉动画
          self.$loading.close();
          //self.$toast.center('上传成功');
          var pic_url = self.$store.state.url + serve_data;
          var item = { url: pic_url, xxx: "" };
          self.send_pic(item);
        },
        error: function (err) {
          //消掉动画
          self.$loading.close();
          self.$toast.center("上传失败,请重新再来");
        },
      });
    },

    imgPreview(file) {
      let self = this;
      let Orientation;
      //去获取拍照时的信息，解决拍出来的照片旋转问题
      Exif.getData(file, function () {
        Orientation = Exif.getTag(this, "Orientation");
      });
      // 看支持不支持FileReader
      if (!file || !window.FileReader) return;
      if (/^image/.test(file.type)) {
        // 创建一个reader
        let reader = new FileReader();
        // 将图片2将转成 base64 格式
        reader.readAsDataURL(file);
        // 读取成功后的回调
        reader.onloadend = function () {
          let result = this.result;
          let img = new Image();
          img.src = result;
          //判断图片是否大于4M,是就直接上传，反之压缩图片
          var pic_size = ((this.result.length * 1.0) / (1024 * 1024)).toFixed(2);

          if (this.result.length <= 1 * 1024 * 1024) {
            self.headerImage = this.result;
            self.postImg();
          } else {
            img.onload = function () {
              let data = tool.compress(img, Orientation);
              self.headerImage = data;
              self.postImg();
            };
          }
        };
      }
    },

    show_full(url) {
      this.$refs.myFullPic.show(url);
    },
    /* 发送图片 end */

    /* 消息处理 start */
    send_txt() {
      if (tool.trim(this.txt) == "") {
        this.txt = "";
        return false;
      }
      //发送字数限制
      if (this.txt.length > 50) {
        this.$toast.bottom("内容太多了,奴家发不动呀~");
        return false;
      }

      //方便本地测试语音
      // if (this.txt == "1") {
      //   var msg_txt = {
      //     "localId": "",
      //     "serverId": "",
      //     "time": 5,
      //     "coin": 0
      //   }
      //   var msg = { msg_type: "voice", msg_txt: msg_txt };
      //   this.send(msg);
      // }

      //消息验证，当发现有违禁信息，需要检查用户的状态

      var msg = { msg_type: "text", msg_txt: this.txt };
      this.send(msg);

      if (this.show_hello) {
        this.show_hello = false;
      }
    },
    send_emoji(item) {
      var emoji_url = item.url;
      var msg = { msg_type: "emoji", msg_txt: emoji_url };
      this.send(msg);
    },
    send_gif(item) {
      var gif_url = item.url;
      var msg = { msg_type: "gif", msg_txt: gif_url };
      this.send(msg);
    },
    send_gift(item) {
      var gif_url = item.url;
      var msg = { msg_type: "gift", msg_txt: gif_url };
      this.send(msg);
    },
    send_pic(item) {
      var pic_url = item.url;
      var msg = { msg_type: "pic", msg_txt: pic_url };
      this.send(msg);
      //发照片,扣除金币
      if (!this.uinfo_from.tel) {
        this.sub_coin_sendpic(50);
      }
    },
    send_topic(item) {
      var txt = item.txt;
      var msg = { msg_type: "text", msg_txt: txt };
      this.send(msg);
      this.close_topic();
    },
    send_sys(item) {
      var msg = { msg_type: item.msg_type, msg_txt: item.msg_txt };
      this.send(msg);
    },
    send_voice(item) {
      var msg_txt = {
        "localId": item.localId,
        "serverId": item.serverId,
        "time": item.time,
        "coin": this.uinfo_from.chat_mny_score2
      }
      var msg = { msg_type: "voice", msg_txt: msg_txt };
      this.send(msg);
      this.close_voice();
    },
    //播放语音
    play_voice(item) {
      //下载
      if(this.voice_play_state === 3){
        return false;
      }

      //更新当前消息
      this.msg_voice_pre = this.msg_voice_cur;
      this.msg_voice_cur = item;

      //第一种情况：首次播放，先下载
      if (item.msg.msg_txt.localId == ''){
        if (item.msg.msg_txt.coin > 0) {
          //语音扣金币
          this.sub_coin_voice(item);
        } else {
          this.do_download_voice(item);
        }
        return false;
      }

        //第二种情况：未播放
        if (this.voice_play_state === 0) {
          this.do_play_voice(item);
          return false;
        }

        //第三种情况：停止播放，开启下一条语音
        if (this.voice_play_state === 1) {
          if(this.msg_voice_pre.msg.msg_txt.localId == item.msg.msg_txt.localId){
            this.do_stop_voice(item);
            return false;
          }
          else{

            this.do_stop_voice(this.msg_voice_pre);
            this.do_play_voice(item);
            return false;
          }
        }
    },
    //检查播放语音金币提示
    check_playcoin_tip(item) {
      var rtn = true;
      //不需要支付金币情况
      if (item.msg.msg_txt.coin <= 0) {
        rtn = false;
        return rtn;
      }
      //需要支付金币情况
      var data = this.$store.state.objVal.voice_play_cointip;
      var exist = data.find(item => item.uid_to === this.to);

        if (exist) {
          if (exist.coin_pre !== item.msg.msg_txt.coin) {
            exist.coin_pre = item.msg.msg_txt.coin;
            rtn = true;
          } else {
            rtn = false;
            return rtn;
          }
        } else {
          var play_coin_item = {
            "uid_to": this.to,
            "coin_pre": item.msg.msg_txt.coin
          };
          data.push(play_coin_item);
        }
        this.$store.commit('set_objVal', {"voice_play_cointip": data});
      return rtn;
    },

    //第一步下载
    do_download_voice(msg_item){
      this.voice_play_state = 3;
      //停止上一个语音
      if (this.msg_voice_pre.msg.msg_txt.localId !== "") {
        this.do_stop_voice(this.msg_voice_pre);
      }

      var server_id = msg_item.msg.msg_txt.serverId;
      var self = this;
          var data = {
            serverId: server_id,
            suc: function(res) {
              //更换为下载后的localId
              msg_item.msg.msg_txt.localId = res; 
              
              self.voice_play_state = 0;
              self.play_voice(msg_item);
            }
          }
          this.wxDownloadVoice(data);
          setTimeout(() => {
            self.voice_play_state = 0;
          }, 5000);
    },
    //第二步播放
    do_play_voice(item){
      this.voice_click_dtm = new Date().getTime();
      this.voice_play_state = 1;
      this.$store.commit('set_objVal', {"voice_state":2});
      
      this.wxPlayVoice(item.msg.msg_txt.localId);
      this.is_playVoice_end(item);
    },
    //监听语音是否播放完毕
    is_playVoice_end(item) {
      var self = this;
      var data = {
          suc: function(res) {
              if (res) {
                var dtm_now = new Date().getTime();
                var diff = dtm_now - self.voice_click_dtm;
                var voice_time = item.msg.msg_txt.time * 1000;
                if (diff >= voice_time) {
                  self.voice_play_state = 0;
                  self.$store.commit('set_objVal', {"voice_state":0});
                }

                //self.$toast.center("结束~diff:"+diff + ";voice_time:" + voice_time);
              }
          }
      }
      this.wxOnVoicePlayEnd(data);
    },
    //停止播放
    do_stop_voice(item) {
      this.voice_play_state = 0;
      this.$store.commit('set_objVal', {"voice_state":0});
      this.wxStopVoice(item.msg.msg_txt.localId);
    },

    //播放语音扣金币------start
    sub_coin_voice(item) {
      var coin = item.msg.msg_txt.coin;
      if (!this.check_coin(coin)) {
          return false;
      }
      //扣金币提示
      if (this.check_playcoin_tip(item)) {
        this.show_payCoin_tip(item);
      } else {
        var coin = item.msg.msg_txt.coin;
        var data = {
          "coin": coin,
          "msg": item
        }
        this.do_sub_coin(data);
      }
      
    },
    show_payCoin_tip(msg) {
            var coin = msg.msg.msg_txt.coin;
              var h =
                    '<div style="display: flex; flex-direction: column; font-size:.9rem; overflow:scroll;width: 99.5%;border-radius:.3em;color: #888;">'  +
                    "<span>对方设置了语音收费，收听本次语音消息需要支付"+coin+"金币，同时对方得到"+coin+"积分，如需收听请点击播放，点击取消则不扣除金币。</span>" +
                    "<span style='margin-top:0.5rem;'>后续不再提示，点击语音消息将默认按照对方设定的收费标准扣除金币，点击播放按钮收听语音~</span>" 
                    + '</div>';
                    this.$refs.myForm_voiceCoin.show(h, {
                        type: "confirm",
                        confirmText: "播放",
                        titleText: "温馨提示",
                        data: {
                          "coin":coin,
                          "msg":msg
                        },
                });
    },
    formact_voiceCoin(type, data) {
                if (type == "clickConfirm") {
                  this.do_sub_coin(data);
                }
    },
    send_voice_res(item) {
              var serverId = item.msg.msg_txt.serverId;
              var msg = { msg_type: "voice_res", msg_txt: serverId };
              this.send(msg);
              this.close_voice();
    },

    do_sub_coin(data) {
      var send_data = {
        uid_from: this.uid,
        uid_to: this.to,
        amount: data.coin,
        type_dtl: "语音支出",
        comment: "",
      };
    var self = this;
    self.act_sub_coin({
        uid: self.uid,
        strSend: JSON.stringify(send_data),
        success: function (res) {
          if (res.state == "1") {
            //扣金币成功
             self.uinfo_from.coin_left -= data.coin;
            self.send_voice_res(data.msg);
            //下载
            self.do_download_voice(data.msg);
          }
        },
    });
    },
    //播放语音扣金币------end

    send: function (msg) {
      //发送检测
      if (!this.send_check()) {
        return false;
      }

      //是否扣金币
      if (this.is_payCoin()) {
        var chat_mny_score = this.uinfo_to.chat_mny_score;
        if (!this.check_coinOrChatCoin(chat_mny_score)) {
          return false;
        }
        this.sub_coin_sendmsg(chat_mny_score);
      } else {//刷新对方用户信息，解决对方中途更改了聊天积分，女生所得跟男生所给不一致
        this.reload_toUserInfo();
      }

      //是否得积分
      if (this.is_receive_score()) {
        this.receive_msg_score();
      }


      //发送消息
      var send_msg = { to: this.to, type: msg.msg_type, txt: msg.msg_txt };
      this.$socket.emit("send_one", send_msg);
      //过滤发送的消息
      if (msg.msg_type == "voice_res") {
        return false;
      }

      this.msg_pre = send_msg;
      this.txt = "";
      //整理消息，本地store中保存
      send_msg.dtm = new Date().Format("yyyy/MM/dd hh:mm:ss");
      this.$store.commit("push_message", send_msg);
      this.$store.commit("set_msg_count");
      // console.log(JSON.stringify(send_msg));

      //任务相关计算（在线动作，打招呼，回复打招呼）
      this.calculate_task();
      
    },

    send_check() {
      var bRtn = true;
      //被封检查
      var kill_info = this.$store.state.kill_info;
      if (kill_info) {
        this.$toast.center("该账号已被系统禁封!");
        this.$refs.show_kill.show();
        bRtn = false;
        return bRtn;
      }

      //环境检查 内部聊天版本不做该检查 /* */
      if (!this.check_env()) {
        bRtn = false;
        return bRtn;
      }
      //检测拉黑情况
      if (!this.check_complain_lahei()) {
        bRtn = false;
        return bRtn;
      }
      //发送频率检查
      if (!this.check_sendRate()) {
        bRtn = false;
        return bRtn;
      }

      return bRtn;
    },

    /* 消息处理 end */

    calculate_task() {
      //存储在线动作
      tool.set_user_action("send_msg");
      //处理打招呼
      tool.set_user_hello(this.txts,this.uinfo_from, this.uinfo_to, true);
      //处理回复
      tool.set_user_answer(this.txts,this.uinfo_from, this.uinfo_to);
    },

    is_payCoin() {
      var rtn = true;
      var chat_mny_score = this.uinfo_to.chat_mny_score;
      //对方设置了免费
      if (chat_mny_score <= 0) {
        rtn = false;
        return rtn;
      }
      //是好友
      if (this.is_friend) {
        rtn = false;
        return rtn;
      }
      //是打招呼消息
      if (tool.is_hello_boy(this.txts)) {
        rtn = false;
        return rtn;
      }
      return rtn;
    },

    is_receive_score() {
      var rtn = true;
      var chat_mny_score = this.uinfo_from.chat_mny_score;
      //自己设置了免费
      if (chat_mny_score <= 0) {
        rtn = false;
        return rtn;
      }
      //最近删除的好友
      if (tool.is_delete_friends(this.to)) {
        rtn = false;
        return rtn;
      }
      //是好友
      if (this.is_friend) {
        rtn = false;
        return rtn;
      }
      //是打招呼消息
      if (tool.is_hello_girl(this.txts)) {
        rtn = false;
        return rtn;
      }
      return rtn;
    },

    reload_toUserInfo() {
      // if (this.uinfo_to.sex == "男生") {
      //   return false;
      // }
      if (this.is_friend) {
        return false;
      }

      var self_msgs = this.txts.filter(item=> item.tag == "self");
        if (self_msgs.length %5 == 0) {
          var self = this;
          self.act_reload_userinfo({
            uid: self.to,
            success: function (u) {
              self.uinfo_to = u;
              // console.log("更新",self.uinfo_to);
            },
          });
        }
    },

    sub_coin_sendmsg(coin_sub) {
      var send_data = {
        uid_from: this.uid,
        uid_to: this.to,
        amount: coin_sub,
        type_dtl: "消息支出",
        comment: "",
      };
      var self = this;
      self.act_sub_coin({
        uid: self.uid,
        strSend: JSON.stringify(send_data),
        success: function (res) {
          if (res.state == "1") {
            //扣金币成功
            self.uinfo_from.coin_left -= coin_sub;

            var chat_mny_score = self.uinfo_to.chat_mny_score;
            var chat_mny_score_new = res.chat_mny_score;
            if (chat_mny_score != chat_mny_score_new) {
              self.uinfo_to.chat_mny_score = chat_mny_score_new;
              self.show_changeCoin_tips();
              //更新对方信息（更新chat_mny_score）
              self.act_reload_userinfo({
                  uid: self.to,
                  success: function (u) {
                    self.uinfo_to = u;
                  },
                });
            } else {
              self.show_payCoin_tips();
            }
          }
        },
      });

      //备注需要调接口
    },

    receive_msg_score() {
      //计算所得积分
      var to_msgs = tool.get_to_msg(this.txts);
      var receive_score = this.get_receive_score(to_msgs);
      if (receive_score <= 0) {
        return false;
      }
      
      //消息上显示加积分
      var item;
      for (var i = 0; i < to_msgs.length; i++) {
        item = to_msgs[i];
        item.receive_score = receive_score;
      }
      
      //计算总积分
      var total_score = to_msgs.length * receive_score;

      //前端加积分
      this.uinfo_from.score_total += total_score;
      //后台加积分
      var send_data = {
            'uid_from': this.uid,
            'uid_to': this.to,
            'amount': total_score,
            'type_dtl': "消息收入",
            'comment': ""
        };

        this.$store.dispatch('act_add_score', {
            'uid': this.uid,
            'strSend': JSON.stringify(send_data),
            success: function (res) {
            }
        });
    },

    get_receive_score(to_msgs) {
      var receive_score = 0;

      if(to_msgs.length <= 0){
        return 0;
      }

      // 找出最小的 dtm_chat_mny
      var to_min_dtm = tool.get_to_Mindtm(to_msgs);
      var current_time = Date.now();
      var time_diff = current_time - to_min_dtm;
      var diff_minutes = time_diff / (1000 * 60);

      var chat_mny_score = this.uinfo_from.chat_mny_score;
      if (diff_minutes <= 3) {
        receive_score = chat_mny_score; // 3分钟内100%
      }
      if (diff_minutes > 3 && diff_minutes <= 30) {
        receive_score = chat_mny_score * 0.8; // 30分钟内80%
      }
      if (diff_minutes > 30 && diff_minutes <= 60 * 3) {
        receive_score = chat_mny_score * 0.6; // 3小时内60%
      }
      if (diff_minutes > 60 * 3 && diff_minutes <= 60 * 6) {
        receive_score = chat_mny_score * 0.5; // 6小时内50%
      }
      if (diff_minutes > 60 * 6 && diff_minutes <= 60 * 12) {
        receive_score = chat_mny_score * 0.1; // 12小时内10%
      }

      receive_score = Math.floor(receive_score);
      
      return receive_score;
    },

    show_payCoin_tips() {
      var txts = this.txts;
      var playCoin_tips = txts.filter(msg => msg.msg.msg_type == "sys_payCoin");
      if (playCoin_tips.length <= 0) {
        var sys_msg = {
          "to": this.to,
          "type": "sys_payCoin",
          "txt": "对方设置了消息收费"+this.uinfo_to.chat_mny_score+"金币/条，成为好友聊天免金币",
          "dtm": new Date().Format("yyyy/MM/dd hh:mm:ss")
        }
        this.$store.commit("push_message", sys_msg);
      }
    },

    show_changeCoin_tips() {
      var txts = this.txts;
      var playCoin_tips = txts.filter(msg => msg.msg.msg_type == "sys_changeCoin");
      if (playCoin_tips.length <= 0) {
        var sys_msg = {
          "to": this.to,
          "type": "sys_changeCoin",
          "txt": "对方更改了消息收费"+this.uinfo_to.chat_mny_score+"金币/条，成为好友聊天免金币",
          "dtm": new Date().Format("yyyy/MM/dd hh:mm:ss")
        }
        this.$store.commit("push_message", sys_msg);
      }
    },

    formact_sendPic(type, data) {
      if (type == "clickConfirm") {
        //金币检查
        if (!this.check_coin(50)) {
          return false;
        }
        this.upload_img();
      }
    },

    check_coinOrChatCoin(coin_pay) {
      var coin_left = this.uinfo_from.coin_left;
      if (coin_left < coin_pay) {
        //提示金币不足
        this.$refs.myConfirm_buyCoinOrchatcoin.show("金币余额不足,请先充值，你也可以选择免费赚金币~", {
          type: "confirm",
          confirmText: "去购买",
          cancelText: "赚金币",
          titleText: "温馨提示",
          data: "",
        });
        return false;
      } else {
        return true;
      }
    },
    formact_buycoinOrchatcoin(type, data) {
      if (type == "clickConfirm") {
        this.get_gotoName();
      }
      if (type == "clickCancel") {
        this.$router.push({ name: "task_coin" });
      }
    },

    get_gotoName() {
      var name = "mycoin";
      //增加跳转到首充的条件
      var uid = this.$store.state.uid;
      var self = this;
      self.get({
        url: "/App/GetVip_AttachInfo/?uid=" + uid,
        success: function (data) {
          if (data.vip_first == "False" && data.svip_first == "False") {
            name = "first_charge";
          }
          
          if (name == "mycoin") {
            self.$router.push({ name: "mycoin" });
          }
          if (name == "first_charge") {
            self.$refs.first_charge.show();
          }
        },
      });
    },

    check_coin(coin_pay) {
      var coin_left = this.uinfo_from.coin_left;
      if (coin_left < coin_pay) {
        //提示金币不足
        this.$refs.myConfirm_buyCoin.show("金币余额不足,请先充值哦", {
          type: "confirm",
          confirmText: "去购买",

          titleText: "温馨提示",
          data: "",
        });
        return false;
      } else {
        return true;
      }
    },

    sub_coin_sendpic(coin_sub) {
      var uid = this.$store.state.uid;
      var send_data = {
        uid_from: uid,
        uid_to: this.uinfo_to.uid,
        amount: coin_sub,
        type_dtl: "发送图片",
        comment: "",
      };
      var self = this;
      self.act_sub_coin({
        uid: uid,
        strSend: JSON.stringify(send_data),
        success: function (res) {
          if (res.state == "1") {
            //扣金币成功
            self.uinfo_from.coin_left -= coin_sub;
          }
        },
      });
    },

    formact_buycoin(type, data) {
      if (type == "clickConfirm") {
        this.$router.push({ name: "mycoin" });
      }
    },

    //点击举报
    report_click() {
      var self = this;
      setTimeout(()=>{
        self.rytDropdown_2 = true;
      },50)
    },

    //投诉举报，拉黑
    onMore() {
      this.rytDropdown_1 = true;
    },
    chooseOption_1(e) {
      if (e.item == "拉黑") {
        if (!this.check_lahei()) {
          return false;
        }

        this.formshow_lahei();
      }
      if (e.item == "聊天举报") {
        this.rytDropdown_2 = true;
      }
      if (e.item == "添加好友") {
        if (!this.check_friendApply()) {
          return false;
        }
        this.formshow_applyFriend();
      }
      // if (e.item == "查看主页") {
      //   this.$router.push({ name: "home_page", params: { topic_uid: this.to } });
      // }
      if (e.item == "修改备注") {
        this.$router.push({ name: "note", params: { uid_to: this.to, note: this.uinfo_to.nick } });
      }
       if (e.item == "礼物投诉") {
       this.$router.push({ name: "gift_tousu" });
      }
      if (e.item == "拜师") {
        this.master();
      }
    },
    chooseOption_2(e) {
      var uid_from, uid_to, c_type, c_type_dtl, com_msg;
      uid_from = this.uinfo_from.uid;
      uid_to = this.uinfo_to.uid;
      c_type = "投诉";
      c_type_dtl = e.item;
      com_msg = "举报成功";
      this.doComplain(uid_from, uid_to, c_type, c_type_dtl, com_msg);
    },

    formshow_lahei() {
      var h = "";
      h += '<div style="color:#888; line-height:1.6rem;">';
      h += "拉黑对方，你将无法接收对方的消息，同时也不能再给对方发消息。确定将对方拉黑?";
      h += "</div>";
      this.$refs.myForm_lahei.show(h, {
        type: "confirm",
        confirmText: "确认",
        titleText: "拉黑对方",
        data: "",
      });
    },

    formact_lahei(type, data) {
      if (type == "clickConfirm") {
        var uid_from, uid_to, c_type, c_type_dtl, com_msg;
        uid_from = this.uinfo_from.uid;
        uid_to = this.uinfo_to.uid;
        c_type = "拉黑";
        c_type_dtl = "";
        com_msg = "拉黑成功";

        this.doComplain(uid_from, uid_to, c_type, c_type_dtl, com_msg);
      }
    },


    doComplain(uid_from, uid_to, c_type, c_type_dtl, com_msg) {
      var self = this;
      var dtm = Date.now();
      var key = uid_to;

      // 检查是否在一分钟内重复举报
      if (dtm - (this.lastComplainTimes[key] || 0) < 60000) {
        this.$toast.center("你刚刚已投诉过此用户啦");
        return false;
      }

      this.lastComplainTimes[key] = dtm;

      self.get({
        url: "/App/Complain/?uid_from=" + uid_from + "&uid_to=" + uid_to + "&c_type=" + c_type + "&c_type_dtl=" + c_type_dtl,
        success: function (data_serve) {
          //后续处理--拉黑情况
          if (data_serve.state == "1") {
            self.$toast.center(com_msg);
            if (c_type == "拉黑") {
              var item = { msg_type: "拉黑", msg_txt: "拉黑" };
              self.send_sys(item);
              self.act_push_mycomplain(uid_from);
              self.act_push_complainmy(uid_from);
            }
          } else {
            self.$toast.center(data_serve.msg);
          }
          if (c_type !== "拉黑") {
            var bll_id = data_serve.msg || "";
            var msg = {
              "txt": "聊天举报",
              "desc": "",
              "id": bll_id,
              "nick": self.uinfo_to.nick,
              "to_uid": self.uinfo_to.uid
            }
            if (bll_id == "最近你已经投诉过Ta啦") {
              return false;
            }
            tool.send_check_msg(self, "check_complain", msg, true);
            var send_msg = { to: self.to, type: "check_complain", txt: msg };
            self.msg_pre = send_msg;
          }
        },
        error: function (err) {},
      });
    },

    //拉黑检测
    check_lahei() {
      var rtn = true;
      //检测拉黑情况
      var my_complain = this.$store.state.my_complain;
      if (tool.hasKey(my_complain, this.to, "uid") >= 0) {
        this.$toast.center("你已经拉黑了对方");
        rtn = false;
        return rtn;
      }
      //亲密度检测
      var message = this.$store.state.message;
      var sum = tool.sum_chart(message, this.to);
      var count_dui = sum.count_to;
      if (count_dui < 1) {
        this.$toast.center("才刚开始聊天呢~再给点儿机会吧");
        rtn = false;
        return rtn;
      }
      return rtn;
    },

    //申请好友，检测
    check_friendApply() {
      var rtn = true;

      //是否已经为好友
      if (this.is_friend) {
        this.$toast.center("你们已经是好友啦~");
        rtn = false;
        return rtn;
      }

      //亲密度检测
      var message = this.$store.state.message;
      var to = this.to;
      var sum = tool.sum_chart(message, to);

      var count_dui = sum.count_to;
      var count_self = sum.count_self;
      var count_total = sum.count_total;
      if (count_dui < 5 || count_self < 5 || count_total < 10) {
        this.$toast.center("你们的亲密度还不够加好友哦");
        rtn = false;
        return rtn;
      }

      return rtn;
    },

    formshow_applyFriend() {
      var h = "";
      h += '<div style="font-size: 0.9rem;line-height: 1.6rem;color: #888;">';
      h += "申请加好友,你需要付出诚意金" + '<span style="color:#f00">' + 300 + "金币</span>,为对方将增加" + '<span style="color:#f00">' + 300 + "魅力值</span><br/>";
      h += '<div style="border:solid 1px #dcdcdc; margin:.3em 0;padding:.3em; border-radius:.3em;">';
      h += "1. 成为好友,将自动关闭敏感屏蔽<br/>";
      h += "2. 成为好友,再也不怕对方走丢了<br/>";
      h += "3. 成为好友,可以离线收(发)消息<br/>";
      h += "</div>";
      h += "点击" + '<span style="color:#f00">确定</span>,马上成为好友';
      h += "</div>";
      this.$refs.myForm_applyFriend.show(h, {
        type: "confirm",
        confirmText: "确定",
        titleText: "申请添加好友",
        data: "",
      });
    },

    formact_applyFriend(type, data) {
      if (type == "clickConfirm") {
        //金币检查
        if (this.check_coin(300)) {
          //扣除金币
          this.sub_coin_applyFriend(300);
        }
      }
    },

    friend_apply(tag) {
      if (tag == 1) {
        //同意加好友
        var item = { msg_type: "sys_friend", msg_txt: "发送-通过" };
        this.send_sys(item);
        //增加积分
        this.$store.dispatch("add_score", {
          uid_from: this.uid,
          uid_to: this.to,
          amount: 300,
          type_dtl: "同意添加好友",
          comment: "",
        });
        //建立好友关系
        var self = this;
        this.$store.dispatch("setFriendRel", {
          uid_from: this.to,
          uid_to: this.uid,
          success: function (d) {
            //self.$toast.bottom('添加成功');
          },
          fail: function (d) {
            //self.$toast.bottom('添加失败');
          },
        });
        //修改当前好友参数
        this.is_friend = true;
      } else {
        //不同意
        var item = { msg_type: "sys_friend", msg_txt: "发送-拒绝" };
        this.send_sys(item);
      }
    },

    set_friend_apply_rst(arr) {
      for (var i in arr) {
        if (
          arr[i].msg.msg_type == "sys_friend" &&
          arr[i].msg.msg_txt == "发送-通过"
        ) {
          this.friend_apply_rst = 1;
          //修改当前好友参数
          this.is_friend = true;
          //刷新当前用户好友列表
          this.$store.dispatch("act_getFriend", this.uid);
          //break;
        }
        if (
          arr[i].msg.msg_type == "sys_friend" &&
          arr[i].msg.msg_txt == "发送-拒绝"
        ) {
          this.friend_apply_rst = 2;
          //break;
        }
        if (
          arr[i].msg.msg_type == "sys_friend" &&
          arr[i].msg.msg_txt == "发送申请"
        ) {
          this.friend_apply_rst = 0;
          //break;
        }
      }

      return this.friend_apply_rst;
    },

    sub_coin_applyFriend(coin_sub) {
      var uid = this.$store.state.uid;
      var send_data = {
        uid_from: this.uid,
        uid_to: this.to,
        amount: coin_sub,
        type_dtl: "添加好友",
        comment: "",
      };
      var self = this;
      self.act_sub_coin({
        uid: uid,
        strSend: JSON.stringify(send_data),
        success: function (res) {
          if (res.state == "1") {
            //扣金币成功
            self.uinfo_from.coin_left -= coin_sub;
            //发送添加申请
            var item = { msg_type: "sys_friend", msg_txt: "发送申请" };
            self.send_sys(item);
          }
        },
      });
    },

    check_sendRate() {
      var bRtn = true;

      var pre_send_time = this.pre_send_time;
      var dtm_now = new Date();
      var sp = dtm_now.getTime() - pre_send_time.getTime();

      if (sp < 200) {
        this.$toast.bottom("发送频率过高哦");
        bRtn = false;
        return bRtn;
      }
      this.pre_send_time = dtm_now;

      return bRtn;
    },

    //检测当前环境是否可玩儿
    check_env() {
      var brtn = true;
      var sysdic = this.$store.state.sysdic;
      if (sysdic) {
        var only_wx = sysdic.only_wx;
        var client = this.$store.state.client;
        if (only_wx == "1" && !client.is_wx) {
          brtn = false;
          //弹出提示，关注微信公众号
          this.show_GuanzhuWx();
        }
      }

      return brtn;
    },

    //拉黑检测
    check_complain_lahei() {
      var bRtn = true;

      var my_complain = this.$store.state.my_complain;
      var complain_my = this.$store.state.complain_my;
      if (tool.hasKey(my_complain, this.to, "uid") >= 0) {
        this.$toast.center("你已经拉黑了对方");
        bRtn = false;
      }
      if (tool.hasKey(complain_my, this.to, "uid") >= 0) {
        this.$toast.center("对方已将你拉黑");
        bRtn = false;
      }

      return bRtn;
    },

    show_ads() {
      var message = this.$store.state.message;
      var to = this.to;
      var sum = tool.sum_chart(message, to);

      var count_dui = sum.count_to;
      var count_self = sum.count_self;
      var count_total = sum.count_total;
      if (count_dui > 0 && count_self > 0 && count_total == 4) {
        if (!this.$cookies.isKey("cookie_show_ads")) {
          var ctxt = '<div style="font-size: 1em;line-height: 1.6em;color: #888;">还没聊几句就要加微信、扣扣的多数都是广告和骗子，为了广大用户的安全，请不要轻易添加对方联系方式，也不要轻易将自己的联系方式给对方。</div>';
          this.$refs.myForm.show(ctxt, {
            type: "alert",
            confirmText: "知道了",
            titleText: "安全提醒",
            data: "",
          });
          this.$cookies.set("cookie_show_ads", 1, 4 * 60 * 60);
        }
      }
    },

    show_GuanzhuWx() {
      var qrcode_url = require("../../assets/img/qrcode_xhc.jpg");
      var gzh_name = "小火柴";
      //加载dic信息
      var sysdic = this.$store.state.sysdic;
      if (sysdic) {
        qrcode_url = sysdic.wx_gzh_qrcode;
        gzh_name = sysdic.wx_gzh_name;
      }

      var h = '<div style="line-height:1.6em;text-align:center;">为了保障您的聊天体验，当前只支持微信环境下聊天，请先关注微信公众号【' + gzh_name + "】<div>" + 
              '<div class="ub ub-ac ub-pc dlg-img"><img src="' + qrcode_url + '" style="margin: 1rem 0"/></div>' +
              '<div style="line-height:1.6em; text-align:center;">更多特权等你来~<div>';
      this.$refs.myForm.show(h, {
        type: "alert",
        confirmText: "微信扫描上方二维码",
        titleText: "温馨提示",
        data: "",
      });
    },

    check_warn() {
      var uid = this.uid;

      var self = this;
        self.get({
          url: "/App/CheckWarn/?uid=" + uid,
          success: function (data) {
            if (data.state == "1") {
              //console.log(data.msg);
              //弹出警告框
              var warn_sec = parseInt(data.msg);
              var ctxt ='<div style=" width: 100%; font-size:.9em;">你的账号被投诉次数过多，即将触发平台封号机制，请文明聊天，聊天过程请不要收到投诉举报/拉黑等情况，以免影响你正常聊天交友，感谢你的配合</div>';
              self.$refs.formshow_warn.show(ctxt, {
                confirmText: "立即兑换",
                titleText: "警告",
                timeout:warn_sec
              });
            }
          },
        });
    },

    check_kill() {
      var cur_user = this.uinfo_from;
      var reg_time = cur_user.reg_time;
      var sex = cur_user.sex;
      var uid = cur_user.uid;
      var msg_flag = false;
      
      if(this.msg_pre.type == 'text') {
        var txt = this.msg_pre.txt;
        if(!!txt) {
          msg_flag = this.check_txt(txt);
        }
      }
      if ((sex == "女生" && reg_time < 86400 * 7) || msg_flag) {
        var self = this;
        self.get({
          url: "/App/CheckKill/?uid=" + uid,
          success: function (data) {
            if (data) {
              //获取封号信息
              var kill_info = self.$store.state.kill_info;
              if (!kill_info) {
                self.act_get_killinfo(uid);
              } else {
                self.$refs.show_kill.show();
              }
            }
          },
        });
      }
    },

    check_txt(txt) {
      var words_num = "1|2|3|4|5|6|7|8|9|0|二|三|四|五|六|七|八|九|壹|贰|叁|肆|伍|陆|柒|捌|玖|①|②|③|④|⑤|⑥|⑦|⑧|⑨";
      var words_Warn = "互看|视频|视屏|扣扣|q|Q|球球|企鹅|加了吗|加了告诉我|我频繁了|";
      var ary_word = words_Warn.split("|");
      var ary_num = words_num.split("|");
      var flag = false;
      //检测 txt【关键词】
      for(var ii in ary_word) {
        var word_item = ary_word[ii];
        if (word_item) {
          if (txt.indexOf(word_item) > -1) {
            return true;
          }
        }
      }
      //检测 txt【数字】
      for (var ii in ary_num) {
        var num_item = ary_num[ii];
        if (num_item) {
          if (txt.indexOf(num_item) > -1) {
            return true;
          }
        }
      }
      return false;
    },

    close_friend_tip() {
      this.friend_tip = false;
    },

    get_history_msg() {
      /**/
      if (!this.checkVip("此功能会员特权功能，成为会员即刻开启查询功能")) {
        return false;
      }

      //为 history_time 赋值
      if (!this.history_time) {
        var message = this.$store.state.message;
        var arr = [];
        var idx = tool.hasKey(message, this.to, "to");
        if (idx >= 0) {
          arr = message[idx]["txts"];
          this.history_time = arr[0].dtm;
        }
      }
      if (this.history_msg.length > 0) {
        this.history_time = this.history_msg[0].dtm;
      }

      var dtm = this.history_time;
      var uid_self = this.uid;
      var uid_to = this.to;
      // console.log(dtm + '---' + uid_self + '---' + uid_to);

      var self = this;
      self.$loading("加载中...");
      setTimeout(() => {
        self.$loading.close();
      }, 5000);

      self.get({
        url:  "/App/GetMsgOff_AB/?dtm=" + dtm + "&uid_self=" +  uid_self + "&uid_to=" + uid_to,
        success: function (data) {
          self.$loading.close();
          // console.log(JSON.stringify(data));
          if (Array.isArray(data)) {
            //Array.isArray(data)
            //data = [{"dtm":"2020-09-23 14:08:13","uid_from":"wx_YE2TV05SANN5A4HW","uid_to":"wx_KB6YBZ1TBRXQ3MPN","state":"success","type":"voice","txt":{"localId":"","serverId":"2H0LKuN0fH6pApY9TYh8AdBgp2-XwK5peHEG6vF8K3Fr5BVr7GETonkiW7hsDxCk","time":3}},{"dtm":"2020-09-23 14:08:25","uid_from":"wx_KB6YBZ1TBRXQ3MPN","uid_to":"wx_YE2TV05SANN5A4HW","state":"success","type":"voice","txt":{"localId":"","serverId":"2H0LKuN0fH6pApY9TYh8AdBgp2-XwK5peHEG6vF8K3Fr5BVr7GETonkiW7hsDxCk","time":12}},{"dtm":"2020-09-23 14:10:15","uid_from":"wx_YE2TV05SANN5A4HW","uid_to":"wx_KB6YBZ1TBRXQ3MPN","state":"success","type":"voice","txt":{"localId":"","serverId":"2H0LKuN0fH6pApY9TYh8AdBgp2-XwK5peHEG6vF8K3Fr5BVr7GETonkiW7hsDxCk","time":9}},{"dtm":"2020-09-23 14:12:31","uid_from":"wx_KB6YBZ1TBRXQ3MPN","uid_to":"wx_YE2TV05SANN5A4HW","state":"success","type":"voice","txt":{"localId":"","serverId":"2H0LKuN0fH6pApY9TYh8AdBgp2-XwK5peHEG6vF8K3Fr5BVr7GETonkiW7hsDxCk","time":3}},{"dtm":"2020-09-23 14:13:38","uid_from":"wx_YE2TV05SANN5A4HW","uid_to":"wx_KB6YBZ1TBRXQ3MPN","state":"success","type":"voice","txt":{"localId":"","serverId":"2H0LKuN0fH6pApY9TYh8AdBgp2-XwK5peHEG6vF8K3Fr5BVr7GETonkiW7hsDxCk","time":7}},{"dtm":"2020-09-23 14:13:50","uid_from":"wx_KB6YBZ1TBRXQ3MPN","uid_to":"wx_YE2TV05SANN5A4HW","state":"success","type":"voice","txt":{"localId":"","serverId":"2H0LKuN0fH6pApY9TYh8AdBgp2-XwK5peHEG6vF8K3Fr5BVr7GETonkiW7hsDxCk","time":6}}];
            //正常情况下返回数组
            if (data.length <= 0) {
              self.history_tip = "";
              return false;
            }

            self.history_tip = "更多历史消息~";
            var sysmsg_dtm = {
              dtm: data[0].dtm,
              type: "sys",
              txt: data[0].dtm,
            };
            data.unshift(sysmsg_dtm);
            self.history_msg = data.concat(self.history_msg);
            self.show_hello = false;
          } else {
            //说明后台没有拉取到值 data = {"dtm":"2020-07-19 00:00:00"};
            var sysmsg_dtm = {
              dtm: data.dtm,
              type: "sys",
              txt: data.dtm,
            };
            self.history_msg.unshift(sysmsg_dtm);
          }

          //本地保存 历史消息
          sessionStorage.setItem(self.to, JSON.stringify(self.history_msg));
        },
      });
    },

    checkVip(msg) {
      var b = true;

      var vip_level = this.uinfo_from.vip_level;
      if (vip_level == 0) {
        //购买会员提示
        this.$refs.myConfirm_buyVip.show(msg, {
          type: "confirm",
          confirmText: "升级会员",
          titleText: "温馨提示",
          data: "",
        });
        return false;
      }

      return b;
    },
    formact_buyVip(type, data) {
      if (type == "clickConfirm") {
        this.$router.push({ name: "vip_center" });
      }
    },

    //获取备注
    get_user_note(){
      var vip_level = this.uinfo_from.vip_level;
      if (vip_level == 0) {
        return false;
      }

      var uid = this.$store.state.uid;
      var uid_to = this.to;

      //防止每次打开聊天页面都进行服务器端加载
      if(sessionStorage.getItem("note"+uid_to))
      {
         return false;
      }

      var self = this;
      this.get({
        url: "/App/Get_UserNote/?uid=" + uid + "&uid_to=" + uid_to,
        success: function (data) {
          sessionStorage.setItem("note"+uid_to, data);
          if(data){
             self.uinfo_to.nick = data;
          }
        }
      });

    },

    get_show_chatScore_tips() {
      var tag = true;
      var chat_mny_score = this.uinfo_from.chat_mny_score;
      //自己设置了免费
      if (chat_mny_score <= 0) {
        tag = false;
      }
      //是好友
      if (this.is_friend) {
        tag = false;
      }
      this.show_chatScore_tips = tag;
    },

    wxSendMsg(msg){
     //console.log("gift:"+JSON.stringify(msg));
      //获取微信模板消息相关参数
      var uid = msg.to;
      var tag = "12";

        var gift_item = {};
        var url = msg.txt;
        var const_data = this.$store.state.const_data;
        var arr = const_data.gift_1.concat(const_data.gift_2);
        var idx = tool.hasKey(arr, url, 'url');
        if (idx >= 0) {
            gift_item = arr[idx];
        }
        else {
            gift_item = arr[0];
        }

        //console.log(JSON.stringify(gift_item));

      var data = {
        "gift_name":gift_item.name,
        "tradeDateTime":msg.dtm,
        "tradeType":"收到礼物",
        "curAmount":gift_item.score + "积分"
      };

      var strData =  JSON.stringify(data);
      var self = this;
      this.post({
        url: "/Common/WxSendMsg2",
        data: { uid: uid, tag:tag, data: strData },
        success: function (serve_data) {
          //console.log(JSON.stringify(data));
        },
      });
    },
    goto_homepage(){
      this.$router.push({ name: "home_page", params: { topic_uid: this.to } });
    },

    goto_chat_specification() {
      this.$router.push({ name: "chat_specification"});
    },

    master() {
      var self_score=this.uinfo_from.score_total;
      var to_score=this.uinfo_to.score_total;

      if(self_score>30000){
         this.$toast.center("当前魅力值超过3万，不可以拜师");
         return false;
      }

      if(to_score<300000){
         this.$toast.center("对方魅力值低于30万，没有资格成为师父");
         return false;
      }

      var item = { msg_type: "拜师", msg_txt: "发起拜师申请" };
      this.send_sys(item);
      this.$toast.center("已发起拜师申请");
    },
    master_rst(rst) {
      var item = { msg_type: "拜师结果", msg_txt: rst };
      if (rst == "拒绝") {
          this.send_sys(item);
      }

      //绑定师徒关系
      if (rst == "同意") {
        var uid,uid_master;
        uid_master = this.uinfo_from.uid;
        uid = this.uinfo_to.uid;
        var self = this;
        self.get({
          url: "/App/SetMasterRel2/?uid=" + uid + "&uid_master=" + uid_master,
          success: function (data) {
            if(data.state=='1'){
               self.send_sys(item);
            }else{
               self.$toast.center(data.msg);
            }
            //console.log(JSON.stringify(data))
          },
        });
      }
    },

    wxsend_tip(){
      var h ="";
      h="<div class='ub ub-ver' style='font-size:.9rem;color: #888;ling-height: 1.2rem;'><span>ta不在线哦，可以通过召唤上线功能，快速通知ta上线，具体方式为给对方送一个礼物，对方会收到离线礼物通知，具体效果如下</span>\
        <div class='ub'>\
           <img style='width: 100%;height: 100%;' src='http://appdata.jscx666.cn/img/wxsend/winsend.png'/>\
        </div>\
        <span style='font-size:.9em;margin-top: .5em;'>若使用了召唤功能，对方不上线，24小时内退还礼物,如需使用召唤功能，点击下方 召唤 按钮即刻体验</span>\
        </div>";
      this.$refs.myForm_wxsend.show(h, {
          type: "confirm",
          confirmText: "召唤",
          titleText: "召唤上线",
          data: "",
        });
    },

    formact_wxsend(type, data) {
      if (type == "clickConfirm") {
         this.ctrl_menu(3);
      }
    },

    set_arr_length(num) {
      this.arr_preLength = num;
    }

  },
};
</script>

<style lang="scss" scoped>
#chat_page_main {
  height: 100%;
  overflow-y: auto;
}

#___file_upload {
  position: absolute;
  left: -999px;
}

.nav-top {
  position: fixed;
  top: 0;
  width: 100%;
  .other-msg {
    display: inline-block;
    margin-left: 0.1rem;
    height: 1.6rem;
    line-height: 1.6rem;
    min-width: 1.6rem;
    border-radius: 50%;
    background-color: #fff;
    color: #333;
    text-align: center;
  }
  .online {
    margin-left: 0.5rem;
    color: #4b0df7;
  }

  .no-online {
    margin-left: 0.5rem;
    color: #666;
  }
}

.fix-applyfriend {
  position: fixed;
  top: 3.3rem;
  width: 90%;
  left: 3%;
  padding: 0.5rem;
  background-color: #fff;
  color: #666;
  border-radius: 1rem;
  font-size: 0.88em;
  line-height: 1.5rem;
  box-shadow: rgb(173, 173, 173) 0px 0px 2px 2px;
  .imp {
    color: rgb(186, 97, 255);
    font-weight: 600;
  }
  .remove {
    width: 1.5rem;
    height: 1.5rem;
  }
}

.info-block {
  padding: 0.4rem;
  margin-top: 2.4rem;
  .info-item {
    padding: 0.8rem;
    border-radius: 0.5rem;
    background-image: url(./../../assets/img/顶部背景图.png);
    background-repeat: repeat;
    box-shadow: 5px 5px 5px rgba(240, 120, 186, 0.4);
    .info-img {
      width: 4rem;
      height: 4rem;
      border-radius: 50%;
    }
    .info-sex-img {
      width: 1.5rem;
      height: 1.5rem;
    }
    .info-sex-age {
      color: #fff;
      margin-right: 0.5rem;
    }
    .info-value {
      color: #fff;
      font-weight: 600;
    }
    .info-center-img {
      width: 4rem;
      height: 4rem;
    }
  }
}

.risk-blobk {
  position: fixed;
  top: 2.7rem;
  left: 0;
  right: 0;
  margin: 0 auto;
  .risk {
    padding: 0.5rem 1rem;
    margin: 0 0.5rem;
    width: 90%;
    background-color: #db8e8e;
    border-radius: 0.3rem;
    .warn {
      margin-right: 0.5rem;
      width: 1.5rem;
      height: 1.5rem;
      background-color: red;
      border-radius: 50%;
      font-size: 1rem;
      line-height: 1rem;
      color: #fff;
    }
    span {
      display: block;
      width: 80%;
      font-size: 0.9rem;
      color: #666;
    }
    .close {
      img {
        width: 1.5rem;
        height: 1.5rem;
      }
    }
  }
}

.msg-block {
  padding: 0 0.8rem 0.8rem;
  margin-bottom: 5rem;
  .msg-system {
      font-size: 0.8rem;
      height: 1.6rem;
      line-height: 1.2rem;
      border-radius: 1rem;
      color: #a6a6a6;
      display: inline-block;
      padding: 0 1.5rem;
  }
  .system-paycoin {
    margin: 0.5rem 0;
    font-size: 0.65rem;
  }
  .system-tips {
    margin-top: 0.5rem;
    font-size: 0.8rem;
    height: 1.6rem;
    line-height: 1.2rem;
    border-radius: 1rem;
    color: #a6a6a6;
    display: inline-block;
    padding: 0 3.3rem;
    .score-prize {
      color:#8a61ff;
    }
  }
  .load-history-msg {
    text-align: center;
    font-size: 0.85rem;
    margin-top: 0.8rem;
    color:#8a61ff;
    line-height: 1.35rem;
    .history-msg-img{
      width: 1.2rem;
      height: 1.2rem;
      margin-right: .2rem;
    }
  }
  .no-history-msg {
    text-align: center;
    font-size: 0.8rem;
    margin-top: 0.8rem;
    color: #dcdcdc;
  }
  .msg-item {
    margin: 0.5rem 0;
    .msg-img {
      width: 2.5rem;
      height: 2.5rem;
      border-radius: 50%;
    }
    .msg-tip{
      color: red;
      display: none;
    }
    .msg-content {
      max-width: 66%;
      line-height: 1.8rem;
      border-radius: 0.3rem;
      padding: 0.5rem;
      color: #333;
      word-wrap: break-word;
    }
    .msg-left-color {
      background-color: #fd94b2;
    }
    .msg-leftVoice-color {
      background-color: #fd94b2;
    }
    .msg-Angle-left {
      width: 0;
      height: 0;
      border-width: 0.5rem;
      border-style: solid;
      border-color: transparent #fd94b2 transparent transparent;
    }
    .msg-right-color {
      background-color: #9ae6e2;
      margin-left: .8rem;
    }
    .msg-Angle-right {
      width: 0;
      height: 0;
      border-width: 0.5rem;
      border-style: solid;
      border-color: transparent transparent transparent #9ae6e2;
    }
    .msg-emoji {
      margin: 0 0.8rem;
      max-height: 5rem;
      max-width: 5rem;
    }
    .msg-gif {
      margin: 0 0.8rem;
      max-width: 35%;
    }
    .msg-pic {
      margin: 0 0.8rem;
      max-width: 40%;
      max-height: 6rem;
    }
    .msg-voice-left {
      margin-left: 0.5rem;
      max-width: 66%;
      .msg-voice {
        padding: 0.5rem;
        min-width: 4rem;
        border-radius: 0.3rem;
        line-height: 1rem;
      }
      img {
        width: 1.5rem;
      }
      .ss {
        margin-left: 0.2rem;
        font-size: 1rem;
        color: #333;
      }
    }
    .loading {
      margin-left: 0.3rem;
      img {
        width: 1rem;
      }
    }
    .no-read {
      margin-left: 0.5rem;
      margin-bottom: 0.2rem;
      .red-point {
        width: 0.5rem;
        height: 0.5rem;
        background-color: red;
        border-radius: 50%;
      }
    }
    .expire {
      margin-left: 0.5rem;
      width: 4rem;
      font-size: 0.65rem;
      color: #888;
    }
    .mag-voice-right {
      margin-right: 0.5rem;
      .msg-voice {
        padding: 0.5rem;
        min-width: 4rem;
        border-radius: 0.3rem;
        line-height: 1rem;
      }
      img {
        width: 1.5rem;
      }
      .ss {
        margin-right: 0.3rem;
        font-size: 1rem;
        color: #333;
      }
    }
    .msg-voice-history {
      margin-right: 0.5rem;
      padding: 0.5rem;
      min-width: 4rem;
      border-radius: 0.3rem;
      line-height: 1rem;
    }
    .gift-block {
      padding: 0.5rem 0.3rem;
      margin: 0.8rem;
      background-color: #e92162;
      border-radius: 0.3rem;
      .gift-txt {
        height: 6.5rem;
        width: 6.5rem;
        margin-right: 0.5rem;
        .msg-gift {
          width: 6rem;
          height: 6rem;
        }
      }
      .gift-info {
        height: 6rem;
        justify-content: space-around;
        .gift-name {
          color: #ffff00;
        }

        .gift-man {
          color: #fff;
          font-size: 0.9rem;
        }

        .gift-integral {
          font-size: 0.9rem;
          color: #fff;
        }
      }
    }
    .msg-sys {
      max-width: 66%;
      line-height: 1.8rem;
      background-color: #9ae6e2;
      border-radius: 0.3rem;
      padding: 0.5rem;
      margin: 0 1rem;
      color: #fff;
      word-wrap: break-word;
    }
    .friend-block {
      margin-left: 1rem;
      line-height: 1.8rem;
      background-color: #00bfff;
      border-radius: 0.3rem;
      padding: 0.5rem 1rem;
      .desc {
        color: #fff;
      }
      .state {
        justify-content: space-between;
      }
      .yes {
        width: 3.5rem;
        height: 1.8rem;
        background-color: #1a9364;
        border-radius: 0.3rem;
        text-align: center;
        line-height: 1.8rem;
        margin-top: 0.8rem;
        margin-right: 2rem;
        color: #fff;
      }
      .no {
        width: 3.5rem;
        height: 1.8rem;
        background-color: #ca4c7b;
        border-radius: 0.3rem;
        text-align: center;
        line-height: 1.8rem;
        margin-top: 0.8rem;
        color: #fff;
      }
    }
  }
  .msg-violate-regulations {
      width: 15rem;
      padding: 0.5rem 0.5rem;
      margin: 1rem 2rem 1rem 3rem;
      background-color: #DEDEDE;
      border-radius: 0.5rem;
      span {
        font-size: 0.75rem;
        color: #FDFDFD;
        label {
          color: rgb(186, 97, 255);
        }
      }
  }
  .add-score {
        margin-top: 0.2rem;
        margin-left: 3.3rem;
        span {
          display: inline-block;
          margin-left: 0.2rem;
          font-size: 0.75rem;
          font-weight: bold;
          color: #888;
        }
        .add {
          margin-left: 0.2rem;
          font-size: 0.75rem;
          font-weight: bold;
          color: #8a61ff;
          img {
            width: 0.9rem;
            height: 0.9rem;
            margin-right: 0.3rem;
          }
        }
    }

    @keyframes add-score {
        0% {
            transform: translateY(0);
            opacity: 1;
        }
        100% {
            transform: translateY(-5rem);
            opacity: 0;
        }
    }

    .add-score-animation-enter-active {
        animation: add-score 3s ease forwards;
    }

    .add-score-animation-leave-active {
        animation: add-score 3s ease forwards;
    }

    .add-score-animation-enter, .add-score-animation-leave-to {
        opacity: 0;
        transform: translateY(-5rem);
    }

  .add-score-right {
    margin-left: 0;  
    margin-right: 3.3rem;
  }
  .sys-msg {
    margin-top: 1rem;
  }
  .summon-online {
    font-weight: bold;
    color:rgb(186, 97, 255);;
  }
  .summon-success {
    margin:0;
    padding: 0;
    width: 100%; 
    text-align: center;
    color:rgb(186, 97, 255);;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.hello-block {
  position: fixed;
  bottom: 5.3rem;
  width: 99%;
  .hello-block-title {
    height: 2rem;
    line-height: 2rem;
    text-align: center;
    font-size: 0.85rem;
    color: rgb(245, 43, 43);
    margin-bottom: 0.5rem;
  }
  .hello-block-pic {
    padding: 0 1rem;
    img {
      max-width: 90%;
    }
    .hello-gif {
      width: 4.5rem;
    }
  }
}

.send-block {
  width: 100%;
  position: fixed;
  bottom: 0;
  box-sizing: border-box;
  background-color: #ededed;
  .send-txt-con {
    margin: 0 0.5rem;
    padding: 0.22rem 0.3em;
    height: 2em;
    line-height: 2rem;
    border-radius: 2rem;
    background-color: #fff;
    border: #dcdcdc 1px solid;
    .send-txt {
      outline: none;
      border: none;
      font-size: 0.95rem;
      font-weight: 500;
      color: #333;
      height: 1.8rem;
      margin: 0 0.5rem;
      padding-left: 0.3rem;
    }
    .btn-send {
      height: 1.8rem;
      line-height: 1.8rem;
      width: 3.6rem;
      text-align: center;
      border: 1px solid #dcdcdc;
      background: linear-gradient( 90deg, #A264E7 0%, #FE9CC0 100%);
      border-radius: 1rem;
      color: #fff;
      span {
        font-size: 0.8rem;
      }
    }
  }
}

.send-img {
  justify-content: space-between;
  margin: 0.5rem;
  .send-img-item {
    width: 1.5rem;
    height: 1.5rem;
  }
}


.ios_light {
  background-color: #F7F7F7;
  .send-block {
    background-color: #F7F7F7;
  }
}
.andriod_light {
  background-color: #EDEDED;
}
//夜间模式
.ios_dark {
    background-color: #1E1E1E;
    .fix-applyfriend {
      background-color: #404040;
      color: #DFDFDF;
      box-shadow: #535151 0px 0px 2px 2px;
    }
    .msg-block {
      .system-tips {
        color: #535050;
      }
      .msg-violate-regulations {
          background-color: #252529;
          span {
            color: #535050;
          }
        }
      .msg-item {
          .msg-left-color {
            background-color: #2F2E33;
            color: #DFDFDF;
          }
          .msg-leftVoice-color {
            background-color: #47464b;
            .ss {
              color: #fff;
            }
          }
          .msg-Angle-left {
            border-color: transparent #2F2E33 transparent transparent;
          }
          .msg-right-color {
            background-color: #402B6A;
            color: #fff;
            .ss {
              color: #fff;
            }
          }
          .msg-Angle-right {
            border-color: transparent transparent transparent #402B6A;
          }
      }
    }
    
    .send-block {
      background-color: #1E1E1E;
      .send-txt-con {
        background-color: #282828;
        border: #2F2E33 1px solid;
      }
      .send-txt {
        color: #DFDFDF;
        background-color: #282828;
      }
      .btn-send {
        border: 1px solid #282828;
      }
    }
}
.andriod_dark {
    background-color: #111111;
    .fix-applyfriend {
      background-color: #404040;
      color: #DFDFDF;
      box-shadow: #6b6969 0px 0px 2px 2px;
    }
    .msg-block {
      .system-tips {
        color: #535050;
      }
      .msg-violate-regulations {
          background-color: #252529;
          span {
            color: #535050;
          }
        }
        .msg-item {
          .msg-left-color {
            background-color: #2F2E33;
            color: #DFDFDF;
          }
          .msg-leftVoice-color {
            background-color: #47464b;
            .ss {
              color: #fff;
            }
          }
          .mag-voice-right {
            .ss {
              color: #fff;
            }
          }
          .msg-Angle-left {
            border-color: transparent #2F2E33 transparent transparent;
          }
          .msg-right-color {
            background-color: #402B6A;
            color: #fff;
          }
          .msg-Angle-right {
            border-color: transparent transparent transparent #402B6A;
          }
      }
    }

    .send-block {
      background-color: #111111;
      .send-txt-con {
        background-color: #282828;
        border: #2F2E33 1px solid;
      }
      .send-txt {
        color: #DFDFDF;
        background-color: #282828;
      }
      .btn-send {
        border: 1px solid #282828;
      }
    }
}
</style>
